//用于恒运详
export const deviceGroupMenu = [
    {
        icon: 'el-icon-school',
        title: '楼栋房间管理',
        id: 14,
        index: 'RoomBedManager',
        subs: [
            {
                icon: 'el-icon-lx-home',
                title: '部门员工管理',
                id: 11,
                index: 'Department'
            },
            {
                icon: 'el-icon-office-building',
                title: '楼栋管理',
                id: 141,
                index: 'BuildView'
            },
            {
                icon: 'el-icon-house',
                title: '房间管理',
                id: 142,
                index: 'RoomSetting'
            },
            {
                icon: 'el-icon-folder',
                title: '床位管理',
                id: 143,
                index: 'BedSetting'
            },
            {
                id: 144,
                index: 'RoomView',
                title: '床位视图',
                icon: 'el-icon-view'
            },
            {
                icon: 'el-icon-link',
                title: '床位重排',
                id: 145,
                index: 'BedRearrangement'
            }
        ]
    },
    {
                icon: 'el-icon-lx-service',
                title: '护工班组管理',
                id: 13,
                index: 'NursingManagement'
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 2,
        index: 'AdmissionOlderList'
    },
    {
        icon: 'el-icon-refrigerator',
        title: '能力评估',
        id: 213,
        index: 'AdmissionPg'
    },
    {
        icon: 'el-icon-refrigerator',
        title: '出院办理',
        id: 4051,
        index: 'LeaveHistoryList'
    },
    {
        icon: 'el-icon-data-line',
        title: '健康监测管理',
        id: 6,
        index: 'healthDeviceHome',
        subs: [
            {
                icon: 'el-icon-lx-wifi',
                title: '体征监测雷达',
                id: 61,
                index: 'healthRadarList'
            },
            {
                icon: 'el-icon-lx-wifi',
                title: '跌倒雷达',
                id: 831,
                index: 'FallRadarList'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '护工手表',
                id: 832,
                index: 'NursingWatch'
            },
            {
                icon: 'el-icon-camera',
                title: '奥瞳摄像头',
                id: 832,
                index: 'AotongCamera'
            },
            {
                icon: 'el-icon-folder',
                title: '床位数据看板',
                id: 68,
                index: 'BedRadarManagement'
            }
        ]
    },
    {
        icon: 'el-icon-phone-outline',
        title: '应急呼叫管理',
        id: 7,
        index: 'Alarmlog'
    },
    {
        icon: 'el-icon-set-up',
        title: '智能设备管理',
        id: 8,
        index: 'deviceManager'
    },
    {
        icon: 'el-icon-setting',
        title: '系统设置',
        id: 9,
        index: 'SetManagement',
        subs: [
            {
                icon: 'el-icon-office-building',
                title: '机构介绍',
                id: 91,
                index: 'GroupInfo'
            },
            {
                icon: 'el-icon-set-up',
                title: '机构阈值管理',
                id: 96,
                index: 'GroupThresholdSetting'
            },
            {
                icon: 'el-icon-postcard',
                title: '信息发布',
                id: 92,
                index: 'InformationMassagePush'
            },
            {
                icon: 'el-icon-collection-tag',
                title: '版本管理',
                id: 98,
                index: 'VersionInfo'
            },
            {
                icon: 'el-icon-office-building',
                title: '数据上报',
                id: 911,
                index: 'groupDbData'
            },
        ]
    }
];

//普通的机构菜单
export const groupMenu = [
    {
        id: 1,
        icon: 'el-icon-office-building',
        title: '院务管理',
        index: 'SystemMain',
        subs: [
            {
                icon: 'el-icon-lx-home',
                title: '部门员工管理',
                id: 11,
                index: 'Department'
            },
            {
                icon: 'el-icon-notebook-2',
                title: '员工培训经历',
                id: 111,
                index: 'EmpTraining'
            },
            {
                icon: 'el-icon-postcard',
                title: '员工证件信息',
                id: 112,
                index: 'EmpCertification'
            },
            // {
            //     icon: 'el-icon-lx-punch',
            //     title: '员工考勤管理',
            //     id: 12,
            //     index: 'KaoqinView',
            // },
            {
                icon: 'el-icon-lx-service',
                title: '护工班组管理',
                id: 13,
                index: 'NursingManagement'
            },
            {
                icon: 'el-icon-school',
                title: '楼栋房间管理',
                id: 14,
                index: 'RoomBedManager',
                subs: [
                    {
                        icon: 'el-icon-office-building',
                        title: '楼栋管理',
                        id: 141,
                        index: 'BuildView'
                    },
                    {
                        icon: 'el-icon-house',
                        title: '房间管理',
                        id: 142,
                        index: 'RoomSetting'
                    },
                    {
                        icon: 'el-icon-folder',
                        title: '床位管理',
                        id: 143,
                        index: 'BedSetting'
                    },
                    {
                        id: 144,
                        index: 'RoomView',
                        title: '床位视图',
                        icon: 'el-icon-view'
                    },
                    {
                        icon: 'el-icon-link',
                        title: '床位重排',
                        id: 145,
                        index: 'BedRearrangement'
                    }
                ]
            },
            {
                icon: 'el-icon-edit',
                title: '工作安全日志',
                id: 15,
                index: 'WorkLogManage',
                subs: [
                    {
                        icon: 'el-icon-document',
                        title: '工作日志管理',
                        id: 151,
                        index: 'WorkLogList'
                    },
                    {
                        icon: 'el-icon-document-remove',
                        title: '工作日志',
                        id: 152,
                        index: 'WorkLog'
                    },
                    {
                        icon: 'el-icon-document',
                        title: '安全检查日志管理',
                        id: 153,
                        index: 'SafeLogList'
                    },
                    {
                        icon: 'el-icon-document-remove',
                        title: '安全检查日志',
                        id: 154,
                        index: 'SafeLog'
                    }
                ]
            },
            {
                icon: 'el-icon-view',
                title: '院内监控看板',
                id: 16,
                index: 'VideoView'
            }
        ]
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 2,
        index: 'AdmissionOlderList',
        subs: [
            {
                icon: 'el-icon-lx-profile',
                title: '入院管理',
                id: 21,
                index: 'AdmissionManager',
                subs: [
                    {
                        icon: 'el-icon-refrigerator',
                        title: '预约咨询',
                        id: 211,
                        index: 'AdmissionConsult'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '取消预约',
                        id: 212,
                        index: 'AdmissionCancel'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '入院评估',
                        id: 213,
                        index: 'AdmissionPg'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '入院办理',
                        id: 214,
                        index: 'AdmissionOlderList'
                    }
                ]
            },
            // {
            //     icon: 'el-icon-lx-group',
            //     title: '居民管理',
            //     id: 29,
            //     index: 'citizenList'
            // },
            {
                icon: 'el-icon-lx-group',
                title: '院内老人管理',
                id: 25,
                index: 'flyOldmanList'
            },
            {
                icon: 'el-icon-document',
                title: '合同管理',
                id: 24,
                index: 'ContractManage'
            },
            {
                icon: 'el-icon-lx-group',
                title: '居家长者管理',
                id: 26,
                index: 'ResidentManager'
            },
            {
                icon: 'el-icon-phone-outline',
                title: '入托管理',
                id: 321,
                index: 'ElderNursingList'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '人证识别记录',
                id: 27,
                index: 'RzjCardRecord'
            },
            {
                icon: 'el-icon-lx-group',
                title: '居民预约咨询',
                id: 255,
                index: 'AdmissionConsultText'
            },
            {
                icon: 'el-icon-lx-global',
                title: '长者地图',
                id: 26,
                index: 'Oldmanmap'
            }
        ]
    },
    {
        icon: 'el-icon-lx-redpacket',
        title: '财务管理',
        id: 3,
        index: 'ChargeManagement',
        subs: [
            {
                icon: 'el-icon-data-analysis',
                title: '月度费用绘总',
                id: 31,
                index: 'MonthFinanceView'
            },
            {
                icon: 'el-icon-money',
                title: '月度应收账款',
                id: 312,
                index: 'MonthReceivableList'
            },
            {
                icon: 'el-icon-tickets',
                title: '费用记录单',
                id: 32,
                index: 'PaymentRecord'
            },
            {
                icon: 'el-icon-wallet',
                title: '消费记录',
                id: 323,
                index: 'ConsumptionRecord'
            },
            {
                icon: 'el-icon-money',
                title: '缴费审核记录',
                id: 324,
                index: 'RechargeRecord'
            },
            {
                icon: 'el-icon-lx-recharge',
                title: '余额管理',
                id: 34,
                index: 'ArrearageList'
            },
            {
                // FeeBindList
                icon: 'el-icon-money',
                title: '月度费用绑定清单',
                id: 342,
                index: 'FeeBindList'
            },
            {
                icon: 'el-icon-suitcase-1',
                title: '收费项目管理',
                id: 33,
                index: 'ChargeCategoryManagement'
            },
            {
                icon: 'el-icon-coordinate',
                title: '老人类别管理',
                id: 36,
                index: 'PersonCategoryManagement'
            },
            {
                icon: 'el-icon-money',
                title: '老人类别减免',
                id: 37,
                index: 'personCategoryReduction'
            },
            {
                icon: 'el-icon-shopping-bag-1',
                title: '套餐管理',
                id: 38,
                index: 'PackageManagement'
            }
        ]
    },
    {
        icon: 'el-icon-place',
        title: '护理管理',
        id: 4,
        index: 'careManage',
        subs: [
            {
                icon: 'el-icon-date',
                title: '排班管理',
                id: 41,
                index: 'SchedulingManage',
                subs: [
                    {
                        icon: 'el-icon-date',
                        title: '护工排班方案',
                        id: 411,
                        index: 'NursingArrangePlan'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '本周排班计划',
                        id: 412,
                        index: 'ThisWeekArrangePlan'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '排班计划审批',
                        id: 413,
                        index: 'SchedulingPlanApproval'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '月排班方案',
                        id: 414,
                        index: 'MonthArrangeScheme'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '本月排班计划',
                        id: 415,
                        index: 'ThisMonthArrangePlan'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '月排班计划审批',
                        id: 416,
                        index: 'SchedulingMonthApproval'
                    }
                ]
            },
            {
                icon: 'el-icon-s-order',
                title: '员工排班管理',
                id: 417,
                index: 'RoomScheduleIndex',
                subs: [
                    {
                        icon: 'el-icon-date',
                        title: '排班管理',
                        id: 4171,
                        index: 'RoomScheduleIndex'
                    },
                    {
                        icon: 'el-icon-time',
                        title: '班次设置',
                        id: 4172,
                        index: 'RoomShiftSetting'
                    },
                    {
                        icon: 'el-icon-user',
                        title: '班组管理',
                        id: 4173,
                        index: 'RoomNursingGroup'
                    },
                    {
                        icon: 'el-icon-s-custom',
                        title: '护理人员',
                        id: 4174,
                        index: 'RoomNursingStaff'
                    },
                    {
                        icon: 'el-icon-notebook-1',
                        title: '考勤记录',
                        id: 4175,
                        index: 'RoomAttendance'
                    },
                    {
                        icon: 'el-icon-refresh',
                        title: '换班申请',
                        id: 4176,
                        index: 'RoomSwapApply'
                    }
                ]
            },
            {
                icon: 'el-icon-notebook-2',
                title: '护理记录',
                id: 42,
                index: 'LifeServiceManagement',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '交班日志',
                        id: 421,
                        index: 'NursingHandoverLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '交班日志管理',
                        id: 422,
                        index: 'HandoverLogLook'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护工护理日志',
                        id: 423,
                        index: 'NursingLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理日志管理',
                        id: 424,
                        index: 'NursingLogManagement'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '班长日志',
                        id: 425,
                        index: 'MonitorLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '班长日志管理',
                        id: 426,
                        index: 'MonitorLogManagement'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '巡查日志',
                        id: 427,
                        index: 'PatrolLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '日常护理记录',
                        id: 428,
                        index: 'TableCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '特殊护理记录',
                        id: 429,
                        index: 'TableSpecialCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '长者护理记录',
                        id: 4210,
                        index: 'TableCareProject'
                    },
                ]
            },
            {
                icon: 'el-icon-notebook-2',
                title: '护理计划',
                id: 4211,
                index: 'CarePlanManage',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理项目管理',
                        id: 42112,
                        index: 'NursingProjectList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理模板管理',
                        id: 42113,
                        index: 'NursingTemplateList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理计划管理',
                        id: 42111,
                        index: 'CarePlanList'
                    },
                    {
                        icon: 'el-icon-user-solid',
                        title: '护理组管理',
                        id: 4220,
                        index: 'NursingGroupManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组增加',
                                id: 42201,
                                index: 'CareNursingGroupAdd'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组变更',
                                id: 42202,
                                index: 'CareNursingGroupChange'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组查询',
                                id: 42203,
                                index: 'CareNursingGroupQuery'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '班次设置',
                                id: 42204,
                                index: 'RoomShiftSetting'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '排班管理',
                                id: 42205,
                                index: 'RoomScheduleIndex'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-date',
                        title: '护理任务管理',
                        id: 4230,
                        index: 'NursingTaskManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务自动生成',
                                id: 42301,
                                index: 'CareNursingTaskGenerate'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务监控',
                                id: 42302,
                                index: 'CareNursingTaskMonitor'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务执行打卡',
                                id: 42303,
                                index: 'CareNursingTaskPunch'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '超时预警',
                                id: 42304,
                                index: 'CareNursingTaskTimeout'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '异常上报',
                                id: 42305,
                                index: 'CareNursingTaskException'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-document',
                        title: '护理记录管理',
                        id: 4240,
                        index: 'CareNursingRecordView'
                    },
                    {
                        icon: 'el-icon-connection',
                        title: '整合查看',
                        id: 4250,
                        index: 'NursingIntegrateReport'
                    },
                    {
                        icon: 'el-icon-data-line',
                        title: '数据统计',
                        id: 4260,
                        index: 'NursingStatsDashboard'
                    },
                    {
                        icon: 'el-icon-money',
                        title: '护理计费',
                        id: 4270,
                        index: 'NursingBillList'
                    }
                ]
            },
            {
                icon: 'el-icon-date',
                title: '入院参观信息',
                id: 406,
                index: 'OldVisitTable'
            },
            {
                icon: 'el-icon-date',
                title: '预约登记表',
                id: 4061,
                index: 'OldReservationTable'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '院民出入登记表',
                id: 407,
                index: 'EldOutTable'
            },
            {
                icon: 'el-icon-lx-crown',
                title: '老人生日',
                id: 43,
                index: 'OldmanBirthday'
            },
            {
                icon: 'el-icon-lx-forward',
                title: '老人请假',
                id: 44,
                index: 'OldmanLeave'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '体检记录',
                id: 48,
                index: 'MedicalCare'
            },
            {
                icon: 'el-icon-guide',
                title: '调房调级',
                id: 45,
                index: 'ReviseRecordList',
                subs: [
                    {
                        icon: 'el-icon-guide',
                        title: '调房调级申请(班长)',
                        id: 452,
                        index: 'changeFeeList'
                    },
                    {
                        icon: 'el-icon-guide',
                        title: '调房调级审批',
                        id: 453,
                        index: 'changeFeeRootList'
                    }
                ]
            },
            {
                icon: 'el-icon-refrigerator',
                title: '出院办理',
                id: 4051,
                index: 'LeaveHistoryList'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '用药管理',
                id: 46,
                index: 'MedicalManage',
                subs: [
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '用药记录',
                        id: 461,
                        index: 'PharmacyRecord'
                    },
                    {
                        icon: 'el-icon-document',
                        title: '历史用药记录',
                        id: 462,
                        index: 'PharmacyHistoryRecord'
                    },
                    {
                        icon: 'el-icon-attract',
                        title: '用药计划',
                        id: 463,
                        index: 'MedicalPlanList'
                    }
                ]
            },
            {
                icon: 'el-icon-food',
                title: '餐饮管理',
                id: 47,
                index: 'canyinManagement',
                subs: [
                    {
                        icon: 'el-icon-chicken',
                        title: '食物管理',
                        id: 471,
                        index: 'FoodManagement'
                    },
                    {
                        icon: 'el-icon-reading',
                        title: '每周菜谱',
                        id: 472,
                        index: 'WeeklyMenu'
                    },
                    {
                        icon: 'el-icon-knife-fork',
                        title: '食品留样记录表',
                        id: 473,
                        index: 'FoodRetention'
                    },
                    {
                        icon: 'el-icon-box',
                        title: '物资项目管理',
                        id: 474,
                        index: 'FoodCatalogManage'
                    },
                    {
                        icon: 'el-icon-shopping-cart-full',
                        title: '物资库存表',
                        id: 475,
                        index: 'FoodStockManage'
                    },
                    {
                        icon: 'el-icon-sell',
                        title: '物资入库表',
                        id: 476,
                        index: 'FoodInTable'
                    },
                    {
                        icon: 'el-icon-sold-out',
                        title: '物资出库表',
                        id: 477,
                        index: 'FoodOutTable'
                    }
                ]
            }
        ]
    },
    {
        id: 1004,
        icon: 'el-icon-trophy',
        title: '居家服务',
        index: 'ServiceManage',
        subs: [
            {
                id: 10040,
                icon: 'el-icon-wallet',
                title: '服务类别管理',
                index: 'ServiceCategoryNew'
            },
            {
                id: 10041,
                icon: 'el-icon-wallet',
                title: '服务商管理',
                index: 'MerchantManagement'
            },
            {
                id: 10042,
                title: '商家服务管理',
                icon: 'el-icon-female',
                index: 'BusinessProgramManage'
            },
            {
                id: 100491,
                title: '服务套餐',
                icon: 'el-icon-suitcase',
                index: 'packageList'
            },
            // {
            //     id: 100492,
            //     title: '老人充值管理',
            //     icon: 'el-icon-tickets',
            //     index: 'UserAccountDetail'
            // },
            {
                id: 10043,
                title: '服务人员管理',
                icon: 'el-icon-coordinate',
                index: 'ServicePersonnel'
            },
            {
                id: 10044,
                title: '服务工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceWorkOrder'
            },
            {
                id: 100441,
                title: '异常工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceErrorWorkOrder'
            },
            {
                id: 10045,
                title: '统计报表',
                icon: 'el-icon-pie-chart',
                index: 'ServiceReport'
            },
            {
                id: 100451,
                title: '老人余额管理',
                icon: 'el-icon-female',
                index: 'OldArrearageList'
            },
            {
                id: 10046,
                title: '评论管理',
                icon: 'el-icon-collection-tag',
                index: 'serviceComment'
            },
            {
                id: 10047,
                title: '商家工单管理',
                icon: 'el-icon-notebook-1',
                index: 'BusinessWorkOrder'
            },
            {
                icon: 'el-icon-lx-group',
                title: '服务人员招聘申请',
                id: 253,
                index: 'ZhaoPinText'
            },
            {
                icon: 'el-icon-lx-group',
                title: '互助养老服务',
                id: 254,
                index: 'huzhuNeed'
            },
            {
                id: 10048,
                title: '预约服务管理',
                icon: 'el-icon-ship',
                index: 'ServiceYuyue'
            },
            {
                id: 10220,
                title: '去电关怀',
                icon: 'el-icon-phone-outline',
                index: 'callSolicitudelList',
                subs: [
                    {
                        icon: 'el-icon-phone-outline',
                        title: '本周待执行',
                        id: 10223,
                        index: 'callSolicitudelList'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '去电关怀计划',
                        id: 10221,
                        index: 'callSolicitudelPlan'
                    },
                    {
                        icon: 'el-icon-document-copy',
                        title: '已执行去电',
                        id: 10222,
                        index: 'callSolicitudelHistory'
                    }
                ]
            },
            {
                id: 10230,
                title: '走访关怀',
                icon: 'el-icon-position',
                index: 'interviewList',
                subs: [
                    {
                        icon: 'el-icon-position',
                        title: '本月待执行',
                        id: 10223,
                        index: 'interviewList'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '走访关怀计划',
                        id: 10231,
                        index: 'interviewPlan'
                    },
                    {
                        icon: 'el-icon-document-copy',
                        title: '已执行走访',
                        id: 10232,
                        index: 'interviewHistory'
                    }
                ]
            }
        ]
    },
    {
        id: 51,
        icon: 'el-icon-help',
        title: '志愿者管理',
        index: 'VolunteerManage',
        subs: [
            {
                id: 521,
                icon: 'el-icon-tickets',
                title: '志愿者服务工单',
                index: 'inspectOrderlist'
            },
            {
                id: 512,
                icon: 'el-icon-service',
                title: '志愿者列表',
                index: 'volunteerlist'
            },
            {
                id: 513,
                icon: 'el-icon-notebook-2',
                title: '志愿者服务列表',
                index: 'volunteerservicelist'
            },
            {
                id: 514,
                icon: 'el-icon-present',
                title: '礼品兑换',
                index: 'volunteergiftsRecord'
            }
        ]
    },
    {
        icon: 'el-icon-truck',
        title: '物资管理',
        id: 5,
        index: 'WuziManage',
        subs: [
            {
                icon: 'el-icon-box',
                title: '物资项目管理',
                id: 51,
                index: 'StorageCatalogManage'
            },
            {
                icon: 'el-icon-shopping-cart-full',
                title: '物资库存表',
                id: 52,
                index: 'StorageStockManage'
            },
            {
                icon: 'el-icon-sell',
                title: '物资入库表',
                id: 53,
                index: 'StorageInTable'
            },
            {
                icon: 'el-icon-sold-out',
                title: '物资出库表',
                id: 54,
                index: 'StorageOutTable'
            },
            {
                icon: 'el-icon-document-checked',
                title: '物资消杀登记',
                id: 55,
                index: 'WuZiResign'
            }
        ]
    },
    {
        icon: 'el-icon-data-line',
        title: '健康监测管理',
        id: 6,
        index: 'healthDeviceHome',
        subs: [
            {
                icon: 'el-icon-lx-wifi',
                title: '体征监测雷达',
                id: 61,
                index: 'healthRadarList'
            },
            {
                icon: 'el-icon-c-scale-to-original',
                title: '睡眠监测带',
                id: 62,
                index: 'SleepMattresslist'
            },
            {
                icon: 'el-icon-watch-1',
                title: '智能手环',
                id: 63,
                index: 'bracelet'
            },
            {
                icon: 'el-icon-finished',
                title: '4G智能拐杖',
                id: 693,
                index: 'cane'
            },
            {
                icon: 'el-icon-bangzhu',
                title: '多功能检测仪',
                id: 64,
                index: 'Followlist'
            },
            {
                icon: 'el-icon-toilet-paper',
                title: '4G血压计',
                id: 65,
                index: 'BloodPressList'
            },
            {
                icon: 'el-icon-toilet-paper',
                title: '4G血糖仪',
                id: 651,
                index: 'BloodSugarList'
            },
            {
                icon: 'el-icon-watch',
                title: '孝心环',
                id: 66,
                index: 'Watchlist'
            },
            {
                icon: 'el-icon-monitor',
                title: '体检一体机',
                id: 67,
                index: 'physicalList'
            },
            {
                icon: 'el-icon-folder',
                title: '床位数据看板',
                id: 68,
                index: 'BedRadarManagement'
            },
            {
                icon: 'el-icon-folder',
                title: '智能药盒',
                id: 69,
                index: 'SmartPillboxList'
            }
        ]
    },
    {
        icon: 'el-icon-phone-outline',
        title: '应急呼叫管理',
        id: 7,
        index: 'Alarmlog',
        subs: [
            {
                icon: 'el-icon-phone-outline',
                title: '告警记录管理',
                id: 70,
                index: 'Alarmlog'
            },
            {
                icon: 'el-icon-data-board',
                title: '智能魔盒',
                id: 71,
                index: 'MagicBox'
            },
            {
                icon: 'el-icon-lx-link',
                title: '4G呼叫网关',
                id: 72,
                index: 'CallGateWayDeviceList'
            },
            {
                icon: 'el-icon-thumb',
                title: '无线呼叫按钮',
                id: 73,
                index: 'AnniuDeviceList'
            },
            {
                icon: 'el-icon-lx-service',
                title: '呼叫中心',
                id: 76,
                index: 'CallCenter',
                subs: [
                    {
                        icon: 'el-icon-notebook-1',
                        title: '呼叫工单管理',
                        id: 761,
                        index: 'CallOrderManagement'
                    },
                    {
                        icon: 'el-icon-notebook-1',
                        title: '呼叫信息管理',
                        id: 762,
                        index: 'CallInformationManagement'
                    },
                    {
                        icon: 'el-icon-notebook-1',
                        title: '投诉工单管理',
                        id: 763,
                        index: 'ComplainOrderManagement'
                    }
                ]
            }
        ]
    },
    {
        icon: 'el-icon-set-up',
        title: '智能设备管理',
        id: 8,
        index: 'IntelligentManage',
        subs: [
            {
                icon: 'el-icon-data-board',
                title: '智能看护设备总览',
                id: 80,
                index: 'device/intellect-overview'
            },
            {
                icon: 'el-icon-house',
                title: '门禁管理',
                id: 81,
                index: 'doorManagement',
                subs: [
                    {
                        icon: 'el-icon-suitcase',
                        title: '门禁读卡器',
                        id: 811,
                        index: 'cardlist'
                    },
                    {
                        icon: 'el-icon-c-scale-to-original',
                        title: '门禁卡',
                        id: 812,
                        index: 'accesslist'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '出入记录',
                        id: 813,
                        index: 'DoorAllRecord'
                    },
                    {
                        icon: 'el-icon-c-scale-to-original',
                        title: '门禁控制卡',
                        id: 814,
                        index: 'AccessControlCard'
                    },
                    {
                        icon: 'el-icon-receiving',
                        title: '门禁卡权限',
                        id: 815,
                        index: 'AccessAuthority'
                    }
                ]
            },
            {
                icon: 'el-icon-user-solid',
                title: '人脸统计',
                id: 86,
                index: 'faceStatistics',
                subs: [
                    {
                        icon: 'el-icon-document',
                        title: '人员库管理',
                        id: 861,
                        index: 'personnelLibrary'
                    },
                    {
                        icon: 'el-icon-lock',
                        title: '人脸门禁管理',
                        id: 862,
                        index: 'faceAccess'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '刷脸记录',
                        id: 863,
                        index: 'brushRecord'
                    },
                    {
                        icon: 'el-icon-s-data',
                        title: '来访统计',
                        id: 864,
                        index: 'visitStatistics',
                        subs: [
                            {
                                icon: 'el-icon-s-data',
                                title: '按天统计',
                                id: 8641,
                                index: 'visitStatistics/day'
                            },
                            {
                                icon: 'el-icon-s-data',
                                title: '按月统计',
                                id: 8642,
                                index: 'visitStatistics/month'
                            },
                            {
                                icon: 'el-icon-s-data',
                                title: '按人统计',
                                id: 8643,
                                index: 'visitStatistics/person'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-warning',
                        title: '异常记录',
                        id: 865,
                        index: 'abnormalRecord'
                    },
                    {
                        icon: 'el-icon-user',
                        title: '人脸录入',
                        id: 866,
                        index: 'faceInput'
                    }
                ]
            },
            {
                icon: 'el-icon-video-camera',
                title: '监控管理',
                id: 82,
                index: 'camera',
                subs: [
                    {
                        icon: 'el-icon-video-camera',
                        title: '萤石云摄像头',
                        id: 821,
                        index: 'YsCamera'
                    },
                    {
                        icon: 'el-icon-video-camera',
                        title: '萤石猫眼',
                        id: 823,
                        index: 'YsPeephole‌'
                    },
                    {
                        icon: 'el-icon-video-camera',
                        title: '电信摄像头',
                        id: 822,
                        index: 'DxCamera'
                    }
                ]
            },
            {
                icon: 'el-icon-help',
                title: '跌倒设备管理',
                id: 83,
                index: 'fallManage',
                subs: [
                    {
                        icon: 'el-icon-lx-wifi',
                        title: '跌倒雷达',
                        id: 831,
                        index: 'FallRadarList'
                    },
                    {
                        icon: 'el-icon-camera',
                        title: '奥瞳摄像头',
                        id: 832,
                        index: 'AotongCamera'
                    }
                ]
            },
            {
                icon: 'el-icon-aim',
                title: '巡更管理',
                id: 84,
                index: 'PatrolManagement',
                subs: [
                    {
                        icon: 'el-icon-mobile',
                        title: '巡更棒管理',
                        id: 841,
                        index: 'PatrollingRod'
                    },
                    {
                        icon: 'el-icon-help',
                        title: '巡更点管理',
                        id: 842,
                        index: 'PatrolPoints'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '巡更记录',
                        id: 843,
                        index: 'PatrollingRecord'
                    },
                    {
                        icon: 'el-icon-s-tools',
                        title: '巡更设置',
                        id: 844,
                        index: 'PatrollingSeting'
                    },
                    {
                        icon: 'el-icon-water-cup',
                        title: '巡更提醒',
                        id: 845,
                        index: 'PatrolReminder'
                    },
                    {
                        icon: 'el-icon-data-analysis',
                        title: '巡更看板',
                        id: 846,
                        index: 'PatrolView'
                    }
                ]
            },
            {
                icon: 'el-icon-umbrella',
                title: '安防设备管理',
                id: 85,
                index: 'safetyManagement',
                subs: [
                    {
                        icon: 'el-icon-magic-stick',
                        title: '红外感应器',
                        id: 851,
                        index: 'LnfraredLnductor'
                    },
                    {
                        icon: 'el-icon-thumb',
                        title: '紧急呼叫器',
                        id: 852,
                        index: 'UrgencyBeeper'
                    },
                    {
                        icon: 'el-icon-cloudy-and-sunny',
                        title: '烟雾报警器',
                        id: 853,
                        index: 'SmogAlertor'
                    },
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '门窗传感器',
                        id: 854,
                        index: 'MagneticLnductor'
                    },
                    {
                        icon: 'el-icon-water-cup',
                        title: '燃气报警器',
                        id: 855,
                        index: 'FuelAlertor'
                    },
                    {
                        icon: 'el-icon-light-rain',
                        title: '溢水报警器',
                        id: 856,
                        index: 'overflowAlertor'
                    }
                ]
            },
            {
                icon: 'el-icon-thumb',
                title: '考勤打卡机管理',
                id: 86,
                index: 'attendanceList'
            },
            {
                icon: 'el-icon-set-up',
                title: '智能电表管理',
                id: 871,
                index: 'eMeterList'
            },
            {
                icon: 'el-icon-receiving',
                title: '智能水表管理',
                id: 872,
                index: 'wMeterList'
            },
            {
                icon: 'el-icon-ice-cream-square',
                title: '无线网卡管理',
                id: 87,
                index: 'wifiDeviceList'
            },
            {
                icon: 'el-icon-files',
                title: '设备管理',
                id: 88,
                index: 'deviceManager'
            },
            {
                icon: 'el-icon-files',
                title: '设备安装统计',
                id: 8869,
                index: 'deviceOldLocationList'
            },
            {
                icon: 'el-icon-document-copy',
                title: '设备日志记录',
                id: 693,
                index: 'DeviceLogTable'
            }
        ]
    },
    {
        icon: 'el-icon-setting',
        title: '系统设置',
        id: 9,
        index: 'SetManagement',
        subs: [
            {
                icon: 'el-icon-office-building',
                title: '机构介绍',
                id: 91,
                index: 'GroupInfo'
            },
            {
                icon: 'el-icon-office-building',
                title: '数据上报',
                id: 911,
                index: 'groupDbData'
            },
            {
                icon: 'el-icon-postcard',
                title: '信息发布',
                id: 92,
                index: 'InformationMassagePush'
            },
            {
                icon: 'el-icon-medal-1',
                title: '活动发布',
                id: 93,
                index: 'ActiveList'
            },
            {
                icon: 'el-icon-medal-1',
                title: '社区活动发布',
                id: 931,
                index: 'communityActivity'
            },
            {
                icon: 'el-icon-printer',
                title: '数据字典',
                id: 94,
                index: 'Dictionary'
            },
            {
                icon: 'el-icon-user',
                title: '自理等级',
                id: 945,
                index: 'LevelCareManage'
            },
            {
                icon: 'el-icon-collection',
                title: '评估项目管理',
                id: 95,
                index: 'EvaluationList'
            },
            {
                icon: 'el-icon-set-up',
                title: '机构阈值管理',
                id: 96,
                index: 'GroupThresholdSetting'
            },
            {
                icon: 'el-icon-service',
                title: '娱乐管理',
                id: 97,
                index: 'entertainmentManagement'
            },
            {
                icon: 'el-icon-collection-tag',
                title: '版本管理',
                id: 98,
                index: 'VersionInfo'
            }
        ]
    }
];

//普通的机构菜单
export const xsgroupMenu = [
    {
        id: 1,
        icon: 'el-icon-office-building',
        title: '院务管理',
        index: 'SystemMain',
        subs: [
            {
                icon: 'el-icon-lx-home',
                title: '部门员工管理',
                id: 11,
                index: 'Department'
            },
            {
                icon: 'el-icon-notebook-2',
                title: '员工培训经历',
                id: 111,
                index: 'EmpTraining'
            },
            {
                icon: 'el-icon-postcard',
                title: '员工证件信息',
                id: 112,
                index: 'EmpCertification'
            },
            {
                icon: 'el-icon-lx-punch',
                title: '员工考勤管理',
                id: 12,
                index: 'KaoqinView'
            },
            {
                icon: 'el-icon-lx-service',
                title: '护工班组管理',
                id: 13,
                index: 'NursingManagement'
            },
            {
                icon: 'el-icon-school',
                title: '楼栋房间管理',
                id: 14,
                index: 'RoomBedManager',
                subs: [
                    {
                        icon: 'el-icon-office-building',
                        title: '楼栋管理',
                        id: 141,
                        index: 'BuildView'
                    },
                    {
                        icon: 'el-icon-house',
                        title: '房间管理',
                        id: 142,
                        index: 'RoomSetting'
                    },
                    {
                        icon: 'el-icon-folder',
                        title: '床位管理',
                        id: 143,
                        index: 'BedSetting'
                    },
                    {
                        id: 144,
                        index: 'RoomView',
                        title: '床位视图',
                        icon: 'el-icon-view'
                    },
                    {
                        icon: 'el-icon-link',
                        title: '床位重排',
                        id: 145,
                        index: 'BedRearrangement'
                    }
                ]
            },
            {
                icon: 'el-icon-edit',
                title: '工作安全日志',
                id: 15,
                index: 'WorkLogManage',
                subs: [
                    {
                        icon: 'el-icon-document',
                        title: '工作日志管理',
                        id: 151,
                        index: 'WorkLogList'
                    },
                    {
                        icon: 'el-icon-document-remove',
                        title: '工作日志',
                        id: 152,
                        index: 'WorkLog'
                    },
                    {
                        icon: 'el-icon-document',
                        title: '安全检查日志管理',
                        id: 153,
                        index: 'SafeLogList'
                    },
                    {
                        icon: 'el-icon-document-remove',
                        title: '安全检查日志',
                        id: 154,
                        index: 'SafeLog'
                    }
                ]
            },
            {
                icon: 'el-icon-view',
                title: '院内监控看板',
                id: 16,
                index: 'VideoView'
            }
        ]
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 2,
        index: 'AdmissionOlderList',
        subs: [
            {
                icon: 'el-icon-lx-profile',
                title: '入院管理',
                id: 21,
                index: 'AdmissionManager',
                subs: [
                    {
                        icon: 'el-icon-refrigerator',
                        title: '预约咨询',
                        id: 211,
                        index: 'AdmissionConsult'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '取消预约',
                        id: 212,
                        index: 'AdmissionCancel'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '入院评估',
                        id: 213,
                        index: 'AdmissionPg'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '入院办理',
                        id: 214,
                        index: 'AdmissionOlderList'
                    }
                ]
            },
            // {
            //     icon: 'el-icon-lx-group',
            //     title: '居民管理',
            //     id: 29,
            //     index: 'citizenList'
            // },
            {
                icon: 'el-icon-document',
                title: '合同管理',
                id: 24,
                index: 'ContractManage'
            },
            {
                icon: 'el-icon-lx-group',
                title: '院内老人管理',
                id: 25,
                index: 'flyOldmanList'
            },
            {
                icon: 'el-icon-lx-group',
                title: '居民预约咨询',
                id: 255,
                index: 'AdmissionConsultText'
            },
            {
                icon: 'el-icon-lx-global',
                title: '长者地图',
                id: 26,
                index: 'Oldmanmap'
            }
        ]
    },
    {
        icon: 'el-icon-lx-redpacket',
        title: '财务管理',
        id: 3,
        index: 'ChargeManagement',
        subs: [
            {
                icon: 'el-icon-data-analysis',
                title: '月度费用绘总',
                id: 31,
                index: 'MonthFinanceView'
            },
            {
                icon: 'el-icon-money',
                title: '月度应收账款',
                id: 312,
                index: 'MonthReceivableList'
            },
            {
                icon: 'el-icon-tickets',
                title: '费用记录单',
                id: 32,
                index: 'PaymentRecord'
            },
            {
                icon: 'el-icon-wallet',
                title: '消费记录',
                id: 323,
                index: 'ConsumptionRecord'
            },
            {
                icon: 'el-icon-money',
                title: '缴费审核记录',
                id: 324,
                index: 'RechargeRecord'
            },
            {
                icon: 'el-icon-lx-recharge',
                title: '余额管理',
                id: 34,
                index: 'ArrearageList'
            },
            {
                icon: 'el-icon-suitcase-1',
                title: '收费项目管理',
                id: 33,
                index: 'ChargeCategoryManagement'
            },
            {
                icon: 'el-icon-coordinate',
                title: '老人类别管理',
                id: 36,
                index: 'PersonCategoryManagement'
            },
            {
                icon: 'el-icon-money',
                title: '老人类别减免',
                id: 37,
                index: 'personCategoryReduction'
            },
            {
                icon: 'el-icon-shopping-bag-1',
                title: '套餐管理',
                id: 38,
                index: 'PackageManagement'
            }
        ]
    },
    {
        icon: 'el-icon-place',
        title: '护理管理',
        id: 4,
        index: 'careManage',
        subs: [
            {
                icon: 'el-icon-date',
                title: '排班管理',
                id: 41,
                index: 'SchedulingManage',
                subs: [
                    {
                        icon: 'el-icon-date',
                        title: '护工排班方案',
                        id: 411,
                        index: 'NursingArrangePlan'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '本周排班计划',
                        id: 412,
                        index: 'ThisWeekArrangePlan'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '排班计划审批',
                        id: 413,
                        index: 'SchedulingPlanApproval'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '月排班方案',
                        id: 414,
                        index: 'MonthArrangeScheme'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '本月排班计划',
                        id: 415,
                        index: 'ThisMonthArrangePlan'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '月排班计划审批',
                        id: 416,
                        index: 'SchedulingMonthApproval'
                    }
                ]
            },
            {
                icon: 'el-icon-notebook-2',
                title: '护理记录',
                id: 42,
                index: 'LifeServiceManagement',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '交班日志',
                        id: 421,
                        index: 'NursingHandoverLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '交班日志管理',
                        id: 422,
                        index: 'HandoverLogLook'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护工护理日志',
                        id: 423,
                        index: 'NursingLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理日志管理',
                        id: 424,
                        index: 'NursingLogManagement'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '班长日志',
                        id: 425,
                        index: 'MonitorLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '班长日志管理',
                        id: 426,
                        index: 'MonitorLogManagement'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '巡查日志',
                        id: 427,
                        index: 'PatrolLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '日常护理记录',
                        id: 428,
                        index: 'TableCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '特殊护理记录',
                        id: 429,
                        index: 'TableSpecialCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '长者护理记录',
                        id: 4210,
                        index: 'TableCareProject'
                    },
                ]
            },
            {
                icon: 'el-icon-notebook-2',
                title: '护理计划',
                id: 4211,
                index: 'CarePlanManage',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理项目管理',
                        id: 42112,
                        index: 'NursingProjectList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理模板管理',
                        id: 42113,
                        index: 'NursingTemplateList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理计划管理',
                        id: 42111,
                        index: 'CarePlanList'
                    },
                    {
                        icon: 'el-icon-user-solid',
                        title: '护理组管理',
                        id: 4220,
                        index: 'NursingGroupManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组增加',
                                id: 42201,
                                index: 'CareNursingGroupAdd'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组变更',
                                id: 42202,
                                index: 'CareNursingGroupChange'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组查询',
                                id: 42203,
                                index: 'CareNursingGroupQuery'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '班次设置',
                                id: 42204,
                                index: 'RoomShiftSetting'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '排班管理',
                                id: 42205,
                                index: 'RoomScheduleIndex'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-date',
                        title: '护理任务管理',
                        id: 4230,
                        index: 'NursingTaskManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务自动生成',
                                id: 42301,
                                index: 'CareNursingTaskGenerate'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务监控',
                                id: 42302,
                                index: 'CareNursingTaskMonitor'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务执行打卡',
                                id: 42303,
                                index: 'CareNursingTaskPunch'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '超时预警',
                                id: 42304,
                                index: 'CareNursingTaskTimeout'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '异常上报',
                                id: 42305,
                                index: 'CareNursingTaskException'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-document',
                        title: '护理记录管理',
                        id: 4240,
                        index: 'CareNursingRecordView'
                    },
                    {
                        icon: 'el-icon-connection',
                        title: '整合查看',
                        id: 4250,
                        index: 'NursingIntegrateReport'
                    },
                    {
                        icon: 'el-icon-data-line',
                        title: '数据统计',
                        id: 4260,
                        index: 'NursingStatsDashboard'
                    },
                    {
                        icon: 'el-icon-money',
                        title: '护理计费',
                        id: 4270,
                        index: 'NursingBillList'
                    }
                ]
            },
            {
                icon: 'el-icon-date',
                title: '入院参观信息',
                id: 406,
                index: 'OldVisitTable'
            },
            {
                icon: 'el-icon-date',
                title: '预约登记表',
                id: 4061,
                index: 'OldReservationTable'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '院民出入登记表',
                id: 407,
                index: 'EldOutTable'
            },
            {
                icon: 'el-icon-lx-crown',
                title: '老人生日',
                id: 43,
                index: 'OldmanBirthday'
            },
            {
                icon: 'el-icon-lx-forward',
                title: '老人请假',
                id: 44,
                index: 'OldmanLeave'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '体检记录',
                id: 48,
                index: 'MedicalCare'
            },
            {
                icon: 'el-icon-guide',
                title: '调房调级',
                id: 45,
                index: 'ReviseRecordList',
                subs: [
                    {
                        icon: 'el-icon-guide',
                        title: '调房调级申请(班长)',
                        id: 452,
                        index: 'changeFeeList'
                    },
                    {
                        icon: 'el-icon-guide',
                        title: '调房调级审批',
                        id: 453,
                        index: 'changeFeeRootList'
                    }
                ]
            },
            {
                icon: 'el-icon-refrigerator',
                title: '出院办理',
                id: 4051,
                index: 'LeaveHistoryList'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '用药管理',
                id: 46,
                index: 'MedicalManage',
                subs: [
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '用药记录',
                        id: 461,
                        index: 'PharmacyRecord'
                    },
                    {
                        icon: 'el-icon-document',
                        title: '历史用药记录',
                        id: 462,
                        index: 'PharmacyHistoryRecord'
                    },
                    {
                        icon: 'el-icon-attract',
                        title: '用药计划',
                        id: 463,
                        index: 'MedicalPlanList'
                    }
                ]
            },
            {
                icon: 'el-icon-food',
                title: '餐饮管理',
                id: 47,
                index: 'canyinManagement',
                subs: [
                    {
                        icon: 'el-icon-chicken',
                        title: '食物管理',
                        id: 471,
                        index: 'FoodManagement'
                    },
                    {
                        icon: 'el-icon-reading',
                        title: '每周菜谱',
                        id: 472,
                        index: 'WeeklyMenu'
                    },
                    {
                        icon: 'el-icon-knife-fork',
                        title: '食品留样记录表',
                        id: 473,
                        index: 'FoodRetention'
                    },
                    {
                        icon: 'el-icon-box',
                        title: '物资项目管理',
                        id: 474,
                        index: 'FoodCatalogManage'
                    },
                    {
                        icon: 'el-icon-shopping-cart-full',
                        title: '物资库存表',
                        id: 475,
                        index: 'FoodStockManage'
                    },
                    {
                        icon: 'el-icon-sell',
                        title: '物资入库表',
                        id: 476,
                        index: 'FoodInTable'
                    },
                    {
                        icon: 'el-icon-sold-out',
                        title: '物资出库表',
                        id: 477,
                        index: 'FoodOutTable'
                    }
                ]
            }
        ]
    },
    {
        id: 1004,
        icon: 'el-icon-trophy',
        title: '居家服务',
        index: 'ServiceManage',
        subs: [
            {
                id: 10040,
                icon: 'el-icon-wallet',
                title: '服务类别管理',
                index: 'ServiceCategoryNew'
            },
            {
                id: 10041,
                icon: 'el-icon-wallet',
                title: '服务商管理',
                index: 'MerchantManagement'
            },
            {
                id: 10042,
                title: '商家服务管理',
                icon: 'el-icon-female',
                index: 'BusinessProgramManage'
            },
            {
                id: 100491,
                title: '服务套餐',
                icon: 'el-icon-suitcase',
                index: 'packageList'
            },
            // {
            //     id: 100492,
            //     title: '老人充值管理',
            //     icon: 'el-icon-tickets',
            //     index: 'UserAccountDetail'
            // },
            {
                id: 10043,
                title: '服务人员管理',
                icon: 'el-icon-coordinate',
                index: 'ServicePersonnel'
            },
            {
                id: 10044,
                title: '服务工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceWorkOrder'
            },
            {
                id: 100441,
                title: '异常工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceErrorWorkOrder'
            },
            {
                id: 10045,
                title: '统计报表',
                icon: 'el-icon-pie-chart',
                index: 'ServiceReport'
            },
            {
                id: 100451,
                title: '老人余额管理',
                icon: 'el-icon-female',
                index: 'OldArrearageList'
            },
            {
                id: 10046,
                title: '评论管理',
                icon: 'el-icon-collection-tag',
                index: 'serviceComment'
            },
            {
                id: 10047,
                title: '商家工单管理',
                icon: 'el-icon-notebook-1',
                index: 'BusinessWorkOrder'
            },
            {
                icon: 'el-icon-lx-group',
                title: '服务人员招聘申请',
                id: 253,
                index: 'ZhaoPinText'
            },
            {
                icon: 'el-icon-lx-group',
                title: '互助养老服务',
                id: 254,
                index: 'huzhuNeed'
            },
            {
                id: 10048,
                title: '预约服务管理',
                icon: 'el-icon-ship',
                index: 'ServiceYuyue'
            },
            {
                id: 10220,
                title: '去电关怀',
                icon: 'el-icon-phone-outline',
                index: 'callSolicitudelList',
                subs: [
                    {
                        icon: 'el-icon-phone-outline',
                        title: '本周待执行',
                        id: 10223,
                        index: 'callSolicitudelList'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '去电关怀计划',
                        id: 10221,
                        index: 'callSolicitudelPlan'
                    },
                    {
                        icon: 'el-icon-document-copy',
                        title: '已执行去电',
                        id: 10222,
                        index: 'callSolicitudelHistory'
                    }
                ]
            },
            {
                id: 10230,
                title: '走访关怀',
                icon: 'el-icon-position',
                index: 'interviewList',
                subs: [
                    {
                        icon: 'el-icon-position',
                        title: '本月待执行',
                        id: 10223,
                        index: 'interviewList'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '走访关怀计划',
                        id: 10231,
                        index: 'interviewPlan'
                    },
                    {
                        icon: 'el-icon-document-copy',
                        title: '已执行走访',
                        id: 10232,
                        index: 'interviewHistory'
                    }
                ]
            }
        ]
    },
    {
        id: 51,
        icon: 'el-icon-help',
        title: '志愿者管理',
        index: 'VolunteerManage',
        subs: [
            {
                id: 521,
                icon: 'el-icon-tickets',
                title: '志愿者服务工单',
                index: 'inspectOrderlist'
            },
            {
                id: 512,
                icon: 'el-icon-service',
                title: '志愿者列表',
                index: 'volunteerlist'
            },
            {
                id: 513,
                icon: 'el-icon-notebook-2',
                title: '志愿者服务列表',
                index: 'volunteerservicelist'
            },
            {
                id: 514,
                icon: 'el-icon-present',
                title: '礼品兑换',
                index: 'volunteergiftsRecord'
            }
        ]
    },
    {
        icon: 'el-icon-truck',
        title: '物资管理',
        id: 5,
        index: 'WuziManage',
        subs: [
            {
                icon: 'el-icon-box',
                title: '物资项目管理',
                id: 51,
                index: 'StorageCatalogManage'
            },
            {
                icon: 'el-icon-shopping-cart-full',
                title: '物资库存表',
                id: 52,
                index: 'StorageStockManage'
            },
            {
                icon: 'el-icon-sell',
                title: '物资入库表',
                id: 53,
                index: 'StorageInTable'
            },
            {
                icon: 'el-icon-sold-out',
                title: '物资出库表',
                id: 54,
                index: 'StorageOutTable'
            },
            {
                icon: 'el-icon-document-checked',
                title: '物资消杀登记',
                id: 55,
                index: 'WuZiResign'
            }
        ]
    },
    {
        icon: 'el-icon-data-line',
        title: '健康监测管理',
        id: 6,
        index: 'healthDeviceHome',
        subs: [
            {
                icon: 'el-icon-lx-wifi',
                title: '体征监测雷达',
                id: 61,
                index: 'healthRadarList'
            },
            {
                icon: 'el-icon-c-scale-to-original',
                title: '睡眠监测带',
                id: 62,
                index: 'SleepMattresslist'
            },
            {
                icon: 'el-icon-watch-1',
                title: '智能手环',
                id: 63,
                index: 'bracelet'
            },
            {
                icon: 'el-icon-finished',
                title: '4G智能拐杖',
                id: 693,
                index: 'cane'
            },
            {
                icon: 'el-icon-bangzhu',
                title: '多功能检测仪',
                id: 64,
                index: 'Followlist'
            },
            {
                icon: 'el-icon-toilet-paper',
                title: '4G血压计',
                id: 65,
                index: 'BloodPressList'
            },
            {
                icon: 'el-icon-watch',
                title: '孝心环',
                id: 66,
                index: 'Watchlist'
            },
            {
                icon: 'el-icon-monitor',
                title: '体检一体机',
                id: 67,
                index: 'physicalList'
            },
            {
                icon: 'el-icon-folder',
                title: '床位数据看板',
                id: 68,
                index: 'BedRadarManagement'
            }
        ]
    },
    {
        icon: 'el-icon-phone-outline',
        title: '应急呼叫管理',
        id: 7,
        index: 'Alarmlog',
        subs: [
            {
                icon: 'el-icon-phone-outline',
                title: '告警记录管理',
                id: 70,
                index: 'Alarmlog'
            },
            {
                icon: 'el-icon-data-board',
                title: '智能魔盒',
                id: 71,
                index: 'MagicBox'
            },
            {
                icon: 'el-icon-lx-link',
                title: '4G呼叫网关',
                id: 72,
                index: 'CallGateWayDeviceList'
            },
            {
                icon: 'el-icon-thumb',
                title: '无线呼叫按钮',
                id: 73,
                index: 'AnniuDeviceList'
            },
            {
                icon: 'el-icon-lx-service',
                title: '呼叫中心',
                id: 76,
                index: 'CallCenter',
                subs: [
                    {
                        icon: 'el-icon-notebook-1',
                        title: '呼叫工单管理',
                        id: 761,
                        index: 'CallOrderManagement'
                    },
                    {
                        icon: 'el-icon-notebook-1',
                        title: '呼叫信息管理',
                        id: 762,
                        index: 'CallInformationManagement'
                    },
                    {
                        icon: 'el-icon-notebook-1',
                        title: '投诉工单管理',
                        id: 763,
                        index: 'ComplainOrderManagement'
                    }
                ]
            }
        ]
    },
    {
        icon: 'el-icon-set-up',
        title: '智能设备管理',
        id: 8,
        index: 'IntelligentManage',
        subs: [
            {
                icon: 'el-icon-data-board',
                title: '智能看护设备总览',
                id: 80,
                index: 'device/intellect-overview'
            },
            {
                icon: 'el-icon-house',
                title: '门禁管理',
                id: 81,
                index: 'doorManagement',
                subs: [
                    {
                        icon: 'el-icon-suitcase',
                        title: '门禁读卡器',
                        id: 811,
                        index: 'cardlist'
                    },
                    {
                        icon: 'el-icon-c-scale-to-original',
                        title: '门禁卡',
                        id: 812,
                        index: 'accesslist'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '出入记录',
                        id: 813,
                        index: 'DoorAllRecord'
                    },
                    {
                        icon: 'el-icon-c-scale-to-original',
                        title: '门禁控制卡',
                        id: 814,
                        index: 'AccessControlCard'
                    },
                    {
                        icon: 'el-icon-receiving',
                        title: '门禁卡权限',
                        id: 815,
                        index: 'AccessAuthority'
                    }
                ]
            },
            {
                icon: 'el-icon-video-camera',
                title: '监控管理',
                id: 82,
                index: 'camera',
                subs: [
                    {
                        icon: 'el-icon-video-camera',
                        title: '萤石云摄像头',
                        id: 821,
                        index: 'YsCamera'
                    },
                    {
                        icon: 'el-icon-video-camera',
                        title: '萤石猫眼',
                        id: 823,
                        index: 'YsPeephole‌'
                    },
                    {
                        icon: 'el-icon-video-camera',
                        title: '电信摄像头',
                        id: 822,
                        index: 'DxCamera'
                    }
                ]
            },
            {
                icon: 'el-icon-help',
                title: '跌倒设备管理',
                id: 83,
                index: 'fallManage',
                subs: [
                    {
                        icon: 'el-icon-lx-wifi',
                        title: '跌倒雷达',
                        id: 831,
                        index: 'FallRadarList'
                    },
                    {
                        icon: 'el-icon-camera',
                        title: '奥瞳摄像头',
                        id: 832,
                        index: 'AotongCamera'
                    }
                ]
            },
            {
                icon: 'el-icon-aim',
                title: '巡更管理',
                id: 84,
                index: 'PatrolManagement',
                subs: [
                    {
                        icon: 'el-icon-mobile',
                        title: '巡更棒管理',
                        id: 841,
                        index: 'PatrollingRod'
                    },
                    {
                        icon: 'el-icon-help',
                        title: '巡更点管理',
                        id: 842,
                        index: 'PatrolPoints'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '巡更记录',
                        id: 843,
                        index: 'PatrollingRecord'
                    },
                    {
                        icon: 'el-icon-s-tools',
                        title: '巡更设置',
                        id: 844,
                        index: 'PatrollingSeting'
                    },
                    {
                        icon: 'el-icon-water-cup',
                        title: '巡更提醒',
                        id: 845,
                        index: 'PatrolReminder'
                    },
                    {
                        icon: 'el-icon-data-analysis',
                        title: '巡更看板',
                        id: 846,
                        index: 'PatrolView'
                    }
                ]
            },
            {
                icon: 'el-icon-umbrella',
                title: '安防设备管理',
                id: 85,
                index: 'safetyManagement',
                subs: [
                    {
                        icon: 'el-icon-magic-stick',
                        title: '红外感应器',
                        id: 851,
                        index: 'LnfraredLnductor'
                    },
                    {
                        icon: 'el-icon-thumb',
                        title: '紧急呼叫器',
                        id: 852,
                        index: 'UrgencyBeeper'
                    },
                    {
                        icon: 'el-icon-cloudy-and-sunny',
                        title: '烟雾报警器',
                        id: 853,
                        index: 'SmogAlertor'
                    },
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '门窗传感器',
                        id: 854,
                        index: 'MagneticLnductor'
                    },
                    {
                        icon: 'el-icon-water-cup',
                        title: '燃气报警器',
                        id: 855,
                        index: 'FuelAlertor'
                    },
                    {
                        icon: 'el-icon-light-rain',
                        title: '溢水报警器',
                        id: 856,
                        index: 'overflowAlertor'
                    }
                ]
            },
            {
                icon: 'el-icon-thumb',
                title: '考勤打卡机管理',
                id: 86,
                index: 'attendanceList'
            },
            {
                icon: 'el-icon-set-up',
                title: '智能电表管理',
                id: 871,
                index: 'eMeterList'
            },
            {
                icon: 'el-icon-receiving',
                title: '智能水表管理',
                id: 872,
                index: 'wMeterList'
            },
            {
                icon: 'el-icon-ice-cream-square',
                title: '无线网卡管理',
                id: 87,
                index: 'wifiDeviceList'
            },
            {
                icon: 'el-icon-files',
                title: '设备管理',
                id: 88,
                index: 'deviceManager'
            }
        ]
    },
    {
        icon: 'el-icon-setting',
        title: '系统设置',
        id: 9,
        index: 'SetManagement',
        subs: [
            {
                icon: 'el-icon-office-building',
                title: '机构介绍',
                id: 91,
                index: 'GroupInfo'
            },
            {
                icon: 'el-icon-office-building',
                title: '数据上报',
                id: 911,
                index: 'groupDbData'
            },
            {
                icon: 'el-icon-postcard',
                title: '信息发布',
                id: 92,
                index: 'InformationMassagePush'
            },
            {
                icon: 'el-icon-medal-1',
                title: '活动发布',
                id: 93,
                index: 'ActiveList'
            },
            {
                icon: 'el-icon-printer',
                title: '数据字典',
                id: 94,
                index: 'Dictionary'
            },
            {
                icon: 'el-icon-user',
                title: '自理等级',
                id: 945,
                index: 'LevelCareManage'
            },
            {
                icon: 'el-icon-collection',
                title: '评估项目管理',
                id: 95,
                index: 'EvaluationList'
            },
            {
                icon: 'el-icon-set-up',
                title: '机构阈值管理',
                id: 96,
                index: 'GroupThresholdSetting'
            },
            {
                icon: 'el-icon-service',
                title: '娱乐管理',
                id: 97,
                index: 'entertainmentManagement'
            },
            {
                icon: 'el-icon-collection-tag',
                title: '版本管理',
                id: 98,
                index: 'VersionInfo'
            }
        ]
    }
];

//社区
export const communityList = [
    {
        id: 1,
        icon: 'el-icon-data-line',
        title: '系统首页',
        index: 'SiteChart'
    },
    {
        id: 2,
        icon: 'el-icon-office-building',
        title: '社区管理',
        index: 'SiteManagement',
        subs: [
            {
                icon: 'el-icon-document',
                title: '基础信息',
                id: 21,
                index: 'BaseInfo'
            },
            {
                icon: 'el-icon-lx-home',
                title: '员工账号管理',
                id: 11,
                index: 'Department'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '多功能室',
                id: 22,
                index: 'MultiRoomList'
            },
            {
                icon: 'el-icon-medal-1',
                title: '课程活动管理',
                id: 231,
                index: 'CourseManage'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '人证识别记录',
                id: 232,
                index: 'RzjCardRecord'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '客流量统计',
                id: 23,
                index: 'SwipeCardRecord'
            },
            {
                icon: 'el-icon-office-building',
                title: '站点介绍',
                id: 24,
                index: 'SiteInfo'
            },
            {
                icon: 'el-icon-postcard',
                title: '信息发布',
                id: 25,
                index: 'InformationMassagePush'
            },
            {
                icon: 'el-icon-medal-1',
                title: '活动发布',
                id: 26,
                index: 'ActiveList'
            },
            {
                icon: 'el-icon-medal-1',
                title: '便民查询',
                id: 27,
                index: 'ConvenientSearchPj'
            }
        ]
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 3,
        index: 'ResidentManager',
        subs: [
            {
                icon: 'el-icon-lx-addressbook',
                title: '长者信息',
                id: 31,
                index: 'ResidentManager'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '咨询接待',
                id: 32,
                index: 'AdmissionConsult'
            },
            {
                icon: 'el-icon-phone-outline',
                title: '入托管理',
                id: 321,
                index: 'ElderNursingList'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '自理评估',
                id: 33,
                index: 'AdmissionPg'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '长者迁出',
                id: 34,
                index: 'ResidentLeave'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '体检记录',
                id: 35,
                index: 'MedicalCare'
            },
            {
                icon: 'el-icon-lx-global',
                title: '长者地图',
                id: 36,
                index: 'Oldmanmap'
            },
            {
                icon: 'el-icon-lx-crown',
                title: '老人生日',
                id: 37,
                index: 'OldmanBirthday'
            },
            {
                icon: 'el-icon-coordinate',
                title: '老人类别管理',
                id: 38,
                index: 'PersonCategoryManagement'
            }
        ]
    },
    {
        id: 4,
        icon: 'el-icon-coordinate',
        title: '居家服务',
        index: 'ServiceManage',
        subs: [
            {
                id: 40,
                icon: 'el-icon-wallet',
                title: '服务类别管理',
                index: 'ServiceCategoryNew'
            },
            {
                id: 43,
                title: '服务人员管理',
                icon: 'el-icon-coordinate',
                index: 'ServicePersonnel'
            },
            {
                id: 44,
                title: '服务工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceWorkOrder'
            },
            {
                id: 441,
                title: '异常工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceErrorWorkOrder'
            },
            {
                id: 45,
                title: '统计报表',
                icon: 'el-icon-pie-chart',
                index: 'ServiceReport'
            },
            {
                id: 451,
                title: '老人余额管理',
                icon: 'el-icon-female',
                index: 'OldArrearageList'
            },
            {
                id: 46,
                title: '评论管理',
                icon: 'el-icon-collection-tag',
                index: 'serviceComment'
            },
            {
                id: 47,
                title: '当月未服务老人',
                icon: 'el-icon-notebook-1',
                index: 'UserNotServiceMonth'
            },
            {
                id: 471,
                title: '未服务原因申请',
                icon: 'el-icon-notebook-1',
                index: 'NotServiceOldReason'
            },
            {
                id: 48,
                title: '预约服务管理',
                icon: 'el-icon-ship',
                index: 'ServiceYuyue'
            },
            {
                id: 49,
                title: '服务套餐',
                icon: 'el-icon-suitcase',
                index: 'packageList'
            }
        ]
    },
    {
        id: 5,
        icon: 'el-icon-help',
        title: '志愿者管理',
        index: 'VolunteerManage',
        subs: [
            {
                id: 51,
                icon: 'el-icon-tickets',
                title: '志愿者服务工单',
                index: 'inspectOrderlist'
            },
            {
                id: 52,
                icon: 'el-icon-service',
                title: '志愿者列表',
                index: 'volunteerlist'
            },
            {
                id: 53,
                icon: 'el-icon-notebook-2',
                title: '志愿者服务列表',
                index: 'volunteerservicelist'
            },
            {
                id: 54,
                icon: 'el-icon-present',
                title: '礼品兑换',
                index: 'volunteergiftsRecord'
            }
        ]
    },
    {
        id: 6,
        icon: 'el-icon-set-up',
        title: '智慧养老',
        index: 'IntelligentManage',
        subs: [
            {
                icon: 'el-icon-data-board',
                title: '智能看护设备总览',
                id: 60,
                index: 'device/intellect-overview'
            },
            {
                icon: 'el-icon-phone-outline',
                title: '告警记录管理',
                id: 61,
                index: 'Alarmlog'
            },
            {
                icon: 'el-icon-data-board',
                title: '智能魔盒',
                id: 62,
                index: 'MagicBox'
            },
            {
                icon: 'el-icon-lx-link',
                title: '4G呼叫网关',
                id: 626,
                index: 'CallGateWayDeviceList'
            },
            {
                icon: 'el-icon-watch-1',
                title: '智能手环',
                id: 63,
                index: 'bracelet'
            },
            {
                icon: 'el-icon-lx-wifi',
                title: '体征监测雷达',
                id: 64,
                index: 'healthRadarList'
            },
            {
                icon: 'el-icon-lx-wifi',
                title: '跌倒监测雷达',
                id: 65,
                index: 'FallRadarList'
            },
            {
                icon: 'el-icon-c-scale-to-original',
                title: '睡眠监测带',
                id: 67,
                index: 'SleepMattresslist'
            },
            // {
            //     icon: 'el-icon-toilet-paper',
            //     title: '4G血糖仪',
            //     id: 68,
            //     index: 'BloodPressList',
            // },
            {
                icon: 'el-icon-toilet-paper',
                title: '4G血压计',
                id: 69,
                index: 'BloodPressList'
            },
            {
                icon: 'el-icon-medal',
                title: '4G血糖仪',
                id: 691,
                index: 'BloodSugarList'
            },
            {
                icon: 'el-icon-camera',
                title: '奥瞳摄像头',
                id: 832,
                index: 'AotongCamera'
            },
            {
                icon: 'el-icon-finished',
                title: '4G智能拐杖',
                id: 693,
                index: 'cane'
            },
            {
                icon: 'el-icon-video-camera',
                title: '监控管理',
                id: 82,
                index: 'camera',
                subs: [
                    {
                        icon: 'el-icon-video-camera',
                        title: '萤石云摄像头',
                        id: 821,
                        index: 'YsCamera'
                    },
                    {
                        icon: 'el-icon-video-camera',
                        title: '萤石猫眼',
                        id: 823,
                        index: 'YsPeephole‌'
                    },
                    {
                        icon: 'el-icon-video-camera',
                        title: '电信摄像头',
                        id: 822,
                        index: 'DxCamera'
                    }
                ]
            },
            {
                icon: 'el-icon-umbrella',
                title: '安防设备管理',
                id: 68,
                index: 'safetyManagement',
                subs: [
                    {
                        icon: 'el-icon-magic-stick',
                        title: '红外感应器',
                        id: 681,
                        index: 'LnfraredLnductor'
                    },
                    {
                        icon: 'el-icon-thumb',
                        title: '紧急呼叫器',
                        id: 682,
                        index: 'UrgencyBeeper'
                    },
                    {
                        icon: 'el-icon-cloudy-and-sunny',
                        title: '烟雾报警器',
                        id: 683,
                        index: 'SmogAlertor'
                    },
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '门窗感应器',
                        id: 684,
                        index: 'MagneticLnductor'
                    },
                    {
                        icon: 'el-icon-water-cup',
                        title: '燃气报警器',
                        id: 685,
                        index: 'FuelAlertor'
                    },
                    {
                        icon: 'el-icon-light-rain',
                        title: '水溢传感器',
                        id: 686,
                        index: 'overflowAlertor'
                    }
                ]
            },

            // {
            //     icon: 'el-icon-data-analysis',
            //     title: '日常活动分析',
            //     id: 692,
            //     index: 'oldActivity',
            // },
            {
                icon: 'el-icon-document-copy',
                title: '设备日志记录',
                id: 693,
                index: 'DeviceLogTable'
            },
            {
                icon: 'el-icon-files',
                title: '设备管理',
                id: 691,
                index: 'deviceManager'
            }
        ]
    }
];

//智慧社区
export const intelligentCommunity = [
    {
        id: 1,
        icon: 'el-icon-data-line',
        title: '系统首页',
        index: 'jChart'
    },
    {
        id: 2,
        icon: 'el-icon-office-building',
        title: '社区管理',
        index: 'SiteManagement',
        subs: [
            {
                icon: 'el-icon-document',
                title: '基础信息',
                id: 21,
                index: 'BaseInfo'
            },
            {
                icon: 'el-icon-lx-home',
                title: '员工账号管理',
                id: 11,
                index: 'Department'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '多功能室',
                id: 22,
                index: 'MultiRoomList'
            },
            {
                icon: 'el-icon-medal-1',
                title: '课程活动管理',
                id: 231,
                index: 'CourseManage'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '人证识别记录',
                id: 232,
                index: 'RzjCardRecord'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '客流量统计',
                id: 23,
                index: 'SwipeCardRecord'
            },
            {
                icon: 'el-icon-office-building',
                title: '站点介绍',
                id: 24,
                index: 'SiteInfo'
            },
            {
                icon: 'el-icon-postcard',
                title: '信息发布',
                id: 25,
                index: 'InformationMassagePush'
            },
            {
                icon: 'el-icon-medal-1',
                title: '活动发布',
                id: 26,
                index: 'ActiveList'
            },
            {
                icon: 'el-icon-medal-1',
                title: '便民查询',
                id: 27,
                index: 'ConvenientSearchPj'
            }
        ]
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 3,
        index: 'ResidentManager',
        subs: [
            {
                icon: 'el-icon-lx-addressbook',
                title: '长者信息',
                id: 31,
                index: 'ResidentManager'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '咨询接待',
                id: 32,
                index: 'AdmissionConsult'
            },
            {
                icon: 'el-icon-phone-outline',
                title: '入托管理',
                id: 321,
                index: 'ElderNursingList'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '自理评估',
                id: 33,
                index: 'AdmissionPg'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '长者迁出',
                id: 34,
                index: 'ResidentLeave'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '体检记录',
                id: 35,
                index: 'MedicalCare'
            },
            {
                icon: 'el-icon-lx-global',
                title: '长者地图',
                id: 36,
                index: 'Oldmanmap'
            },
            {
                icon: 'el-icon-lx-crown',
                title: '老人生日',
                id: 37,
                index: 'OldmanBirthday'
            },
            {
                icon: 'el-icon-coordinate',
                title: '老人类别管理',
                id: 38,
                index: 'PersonCategoryManagement'
            }
        ]
    },
    {
        id: 4,
        icon: 'el-icon-coordinate',
        title: '居家服务',
        index: 'ServiceManage',
        subs: [
            {
                id: 40,
                icon: 'el-icon-wallet',
                title: '服务类别管理',
                index: 'ServiceCategoryNew'
            },
            {
                id: 43,
                title: '服务人员管理',
                icon: 'el-icon-coordinate',
                index: 'ServicePersonnel'
            },
            {
                id: 44,
                title: '服务工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceWorkOrder'
            },
            {
                id: 441,
                title: '异常工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceErrorWorkOrder'
            },
            {
                id: 45,
                title: '统计报表',
                icon: 'el-icon-pie-chart',
                index: 'ServiceReport'
            },
            {
                id: 451,
                title: '老人余额管理',
                icon: 'el-icon-female',
                index: 'OldArrearageList'
            },
            {
                id: 46,
                title: '评论管理',
                icon: 'el-icon-collection-tag',
                index: 'serviceComment'
            },
            {
                id: 47,
                title: '当月未服务老人',
                icon: 'el-icon-notebook-1',
                index: 'UserNotServiceMonth'
            },
            {
                id: 48,
                title: '预约服务管理',
                icon: 'el-icon-ship',
                index: 'ServiceYuyue'
            },
            {
                id: 49,
                title: '服务套餐',
                icon: 'el-icon-suitcase',
                index: 'packageList'
            }
        ]
    },
    {
        id: 5,
        icon: 'el-icon-help',
        title: '志愿者管理',
        index: 'VolunteerManage',
        subs: [
            {
                id: 51,
                icon: 'el-icon-tickets',
                title: '志愿者服务工单',
                index: 'inspectOrderlist'
            },
            {
                id: 52,
                icon: 'el-icon-service',
                title: '志愿者列表',
                index: 'volunteerlist'
            },
            {
                id: 53,
                icon: 'el-icon-notebook-2',
                title: '志愿者服务列表',
                index: 'volunteerservicelist'
            },
            {
                id: 54,
                icon: 'el-icon-present',
                title: '礼品兑换',
                index: 'volunteergiftsRecord'
            }
        ]
    },
    {
        id: 6,
        icon: 'el-icon-set-up',
        title: '智慧养老',
        index: 'IntelligentManage',
        subs: [
            {
                icon: 'el-icon-data-board',
                title: '智能看护设备总览',
                id: 60,
                index: 'device/intellect-overview'
            },
            {
                icon: 'el-icon-phone-outline',
                title: '告警记录管理',
                id: 61,
                index: 'Alarmlog'
            },
            {
                icon: 'el-icon-data-board',
                title: '智能魔盒',
                id: 62,
                index: 'MagicBox'
            },
            {
                icon: 'el-icon-lx-link',
                title: '4G呼叫网关',
                id: 626,
                index: 'CallGateWayDeviceList'
            },
            {
                icon: 'el-icon-watch-1',
                title: '智能手环',
                id: 63,
                index: 'bracelet'
            },
            {
                icon: 'el-icon-lx-wifi',
                title: '体征监测雷达',
                id: 64,
                index: 'healthRadarList'
            },
            {
                icon: 'el-icon-c-scale-to-original',
                title: '睡眠监测带',
                id: 67,
                index: 'SleepMattresslist'
            },
            // {
            //     icon: 'el-icon-toilet-paper',
            //     title: '4G血糖仪',
            //     id: 68,
            //     index: 'BloodPressList',
            // },
            {
                icon: 'el-icon-toilet-paper',
                title: '4G血压计',
                id: 69,
                index: 'BloodPressList'
            },
            {
                icon: 'el-icon-medal',
                title: '4G血糖仪',
                id: 691,
                index: 'BloodSugarList'
            },
            {
                icon: 'el-icon-finished',
                title: '4G智能拐杖',
                id: 693,
                index: 'cane'
            },
            {
                icon: 'el-icon-camera',
                title: '奥瞳摄像头',
                id: 832,
                index: 'AotongCamera'
            },
            {
                icon: 'el-icon-video-camera',
                title: '监控管理',
                id: 82,
                index: 'camera',
                subs: [
                    {
                        icon: 'el-icon-video-camera',
                        title: '萤石云摄像头',
                        id: 821,
                        index: 'YsCamera'
                    },
                    {
                        icon: 'el-icon-video-camera',
                        title: '萤石猫眼',
                        id: 823,
                        index: 'YsPeephole‌'
                    },
                    {
                        icon: 'el-icon-video-camera',
                        title: '电信摄像头',
                        id: 822,
                        index: 'DxCamera'
                    }
                ]
            },
            {
                icon: 'el-icon-umbrella',
                title: '安防设备管理',
                id: 68,
                index: 'safetyManagement',
                subs: [
                    {
                        icon: 'el-icon-magic-stick',
                        title: '红外感应器',
                        id: 681,
                        index: 'LnfraredLnductor'
                    },
                    {
                        icon: 'el-icon-thumb',
                        title: '紧急呼叫器',
                        id: 682,
                        index: 'UrgencyBeeper'
                    },
                    {
                        icon: 'el-icon-cloudy-and-sunny',
                        title: '烟雾报警器',
                        id: 683,
                        index: 'SmogAlertor'
                    },
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '门窗感应器',
                        id: 684,
                        index: 'MagneticLnductor'
                    },
                    {
                        icon: 'el-icon-water-cup',
                        title: '燃气报警器',
                        id: 685,
                        index: 'FuelAlertor'
                    },
                    {
                        icon: 'el-icon-light-rain',
                        title: '水溢传感器',
                        id: 686,
                        index: 'overflowAlertor'
                    }
                ]
            },
            // {
            //     icon: 'el-icon-data-analysis',
            //     title: '日常活动分析',
            //     id: 692,
            //     index: 'oldActivity',
            // },
            {
                icon: 'el-icon-document-copy',
                title: '设备日志记录',
                id: 693,
                index: 'DeviceLogTable'
            },
            {
                icon: 'el-icon-files',
                title: '设备管理',
                id: 691,
                index: 'deviceManager'
            },
            {
                icon: 'el-icon-files',
                title: '设备安装统计',
                id: 8869,
                index: 'deviceOldLocationList'
            }
        ]
    }
];

// 简易机构
export const sampleGroup = [
    {
        id: 1,
        icon: 'el-icon-office-building',
        title: '院务管理',
        index: 'SystemMain',
        subs: [
            {
                icon: 'el-icon-lx-home',
                title: '部门员工管理',
                id: 11,
                index: 'Department'
            },
            {
                icon: 'el-icon-lx-punch',
                title: '员工考勤管理',
                id: 12,
                index: 'KaoqinView'
            },
            {
                icon: 'el-icon-lx-service',
                title: '护工班组管理',
                id: 13,
                index: 'NursingManagement'
            },
            {
                icon: 'el-icon-school',
                title: '楼栋房间管理',
                id: 14,
                index: 'RoomBedManager',
                subs: [
                    {
                        icon: 'el-icon-office-building',
                        title: '楼栋管理',
                        id: 141,
                        index: 'BuildView'
                    },
                    {
                        icon: 'el-icon-house',
                        title: '房间管理',
                        id: 142,
                        index: 'RoomSetting'
                    },
                    {
                        icon: 'el-icon-folder',
                        title: '床位管理',
                        id: 143,
                        index: 'BedSetting'
                    },
                    {
                        id: 144,
                        index: 'RoomView',
                        title: '床位视图',
                        icon: 'el-icon-view'
                    },
                    {
                        icon: 'el-icon-link',
                        title: '床位重排',
                        id: 145,
                        index: 'BedRearrangement'
                    },
                    {
                        icon: 'el-icon-female',
                        title: '床位入住',
                        id: 146,
                        index: 'BedOldSetting'
                    }
                ]
            },
            {
                icon: 'el-icon-view',
                title: '院内监控看板',
                id: 16,
                index: 'VideoView'
            }
        ]
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 2,
        index: 'ResidentManager',
        subs: [
            {
                icon: 'el-icon-lx-addressbook',
                title: '老人列表',
                id: 21,
                index: 'ResidentManager'
            },
            {
                icon: 'el-icon-lx-profile',
                title: '入院管理',
                id: 22,
                index: 'AdmissionManager',
                subs: [
                    {
                        icon: 'el-icon-refrigerator',
                        title: '预约咨询',
                        id: 221,
                        index: 'AdmissionConsult'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '入院办理',
                        id: 224,
                        index: 'AdmissionOlderList'
                    }
                ]
            },
            {
                icon: 'el-icon-refrigerator',
                title: '出院办理',
                id: 23,
                index: 'LeaveHistoryList'
            },
            {
                icon: 'el-icon-document',
                title: '合同管理',
                id: 24,
                index: 'ContractManage'
            },
            {
                icon: 'el-icon-lx-global',
                title: '长者地图',
                id: 25,
                index: 'Oldmanmap'
            }
        ]
    },
    {
        icon: 'el-icon-lx-redpacket',
        title: '财务管理',
        id: 3,
        index: 'ChargeManagement',
        subs: [
            {
                icon: 'el-icon-data-analysis',
                title: '财务报表',
                id: 31,
                index: 'financeView'
            },
            {
                icon: 'el-icon-money',
                title: '月度应收账款',
                id: 312,
                index: 'MonthReceivableList'
            },
            {
                icon: 'el-icon-tickets',
                title: '费用记录单',
                id: 32,
                index: 'PaymentRecord'
            },
            {
                icon: 'el-icon-wallet',
                title: '消费记录',
                id: 323,
                index: 'ConsumptionRecord'
            },
            {
                icon: 'el-icon-money',
                title: '缴费审核记录',
                id: 324,
                index: 'RechargeRecord'
            },
            {
                icon: 'el-icon-lx-recharge',
                title: '余额管理',
                id: 34,
                index: 'ArrearageList'
            },
            {
                icon: 'el-icon-suitcase-1',
                title: '收费项目管理',
                id: 33,
                index: 'ChargeCategoryManagement'
            },
            {
                icon: 'el-icon-coordinate',
                title: '老人类别管理',
                id: 36,
                index: 'PersonCategoryManagement'
            },
            {
                icon: 'el-icon-money',
                title: '老人类别减免',
                id: 37,
                index: 'personCategoryReduction'
            }
        ]
    },
    {
        icon: 'el-icon-coordinate',
        title: '护理管理',
        id: 4,
        index: 'careManage',
        subs: [
            {
                icon: 'el-icon-notebook-2',
                title: '护理记录',
                id: 42,
                index: 'LifeServiceManagement',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '巡查日志',
                        id: 427,
                        index: 'PatrolLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '日常护理记录',
                        id: 428,
                        index: 'TableCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '特殊护理记录',
                        id: 429,
                        index: 'TableSpecialCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '长者护理记录',
                        id: 4210,
                        index: 'TableCareProject'
                    },
                ]
            },
            {
                icon: 'el-icon-notebook-2',
                title: '护理计划',
                id: 4211,
                index: 'CarePlanManage',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理项目管理',
                        id: 42112,
                        index: 'NursingProjectList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理模板管理',
                        id: 42113,
                        index: 'NursingTemplateList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理计划管理',
                        id: 42111,
                        index: 'CarePlanList'
                    },
                    {
                        icon: 'el-icon-user-solid',
                        title: '护理组管理',
                        id: 4220,
                        index: 'NursingGroupManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组增加',
                                id: 42201,
                                index: 'CareNursingGroupAdd'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组变更',
                                id: 42202,
                                index: 'CareNursingGroupChange'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组查询',
                                id: 42203,
                                index: 'CareNursingGroupQuery'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '班次设置',
                                id: 42204,
                                index: 'RoomShiftSetting'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '排班管理',
                                id: 42205,
                                index: 'RoomScheduleIndex'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-date',
                        title: '护理任务管理',
                        id: 4230,
                        index: 'NursingTaskManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务自动生成',
                                id: 42301,
                                index: 'CareNursingTaskGenerate'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务监控',
                                id: 42302,
                                index: 'CareNursingTaskMonitor'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务执行打卡',
                                id: 42303,
                                index: 'CareNursingTaskPunch'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '超时预警',
                                id: 42304,
                                index: 'CareNursingTaskTimeout'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '异常上报',
                                id: 42305,
                                index: 'CareNursingTaskException'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-document',
                        title: '护理记录管理',
                        id: 4240,
                        index: 'CareNursingRecordView'
                    },
                    {
                        icon: 'el-icon-connection',
                        title: '整合查看',
                        id: 4250,
                        index: 'NursingIntegrateReport'
                    },
                    {
                        icon: 'el-icon-data-line',
                        title: '数据统计',
                        id: 4260,
                        index: 'NursingStatsDashboard'
                    },
                    {
                        icon: 'el-icon-money',
                        title: '护理计费',
                        id: 4270,
                        index: 'NursingBillList'
                    }
                ]
            },
            {
                icon: 'el-icon-lx-crown',
                title: '老人生日',
                id: 43,
                index: 'OldmanBirthday'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '体检记录',
                id: 48,
                index: 'MedicalCare'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '用药管理',
                id: 46,
                index: 'MedicalManage',
                subs: [
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '用药记录',
                        id: 461,
                        index: 'PharmacyRecord'
                    },
                    {
                        icon: 'el-icon-document',
                        title: '历史用药记录',
                        id: 462,
                        index: 'PharmacyHistoryRecord'
                    },
                    {
                        icon: 'el-icon-attract',
                        title: '用药计划',
                        id: 463,
                        index: 'MedicalPlanList'
                    }
                ]
            },
            {
                icon: 'el-icon-food',
                title: '餐饮管理',
                id: 47,
                index: 'canyinManagement',
                subs: [
                    {
                        icon: 'el-icon-chicken',
                        title: '食物管理',
                        id: 471,
                        index: 'FoodManagement'
                    },
                    {
                        icon: 'el-icon-reading',
                        title: '每周菜谱',
                        id: 472,
                        index: 'WeeklyMenu'
                    }
                ]
            }
        ]
    },
    {
        id: 5,
        icon: 'el-icon-coordinate',
        title: '居家服务',
        index: 'ServiceManage',
        subs: [
            {
                id: 50,
                icon: 'el-icon-wallet',
                title: '服务类别管理',
                index: 'ServiceCategoryNew'
            },
            {
                id: 51,
                icon: 'el-icon-wallet',
                title: '服务商管理',
                index: 'MerchantManagement'
            },
            {
                id: 52,
                title: '商家服务管理',
                icon: 'el-icon-female',
                index: 'BusinessProgramManage'
            },
            {
                id: 53,
                title: '服务人员管理',
                icon: 'el-icon-coordinate',
                index: 'ServicePersonnel'
            },
            {
                id: 100492,
                title: '老人充值管理',
                icon: 'el-icon-tickets',
                index: 'UserAccountDetail'
            },
            {
                id: 54,
                title: '服务工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceWorkOrder'
            },
            {
                id: 441,
                title: '异常工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceErrorWorkOrder'
            },
            {
                id: 55,
                title: '统计报表',
                icon: 'el-icon-pie-chart',
                index: 'ServiceReport'
            },
            {
                id: 451,
                title: '老人余额管理',
                icon: 'el-icon-female',
                index: 'OldArrearageList'
            },
            {
                id: 56,
                title: '评论管理',
                icon: 'el-icon-collection-tag',
                index: 'serviceComment'
            },
            {
                id: 58,
                title: '预约服务管理',
                icon: 'el-icon-ship',
                index: 'ServiceYuyue'
            },
            {
                id: 59,
                title: '服务套餐',
                icon: 'el-icon-suitcase',
                index: 'packageList'
            },
            {
                id: 510,
                title: '服务套餐记录',
                icon: 'el-icon-collection',
                index: 'packageRecord'
            },
            {
                id: 511,
                title: '套餐剩余次数',
                icon: 'el-icon-notebook-1',
                index: 'packageRemindTime'
            }
        ]
    },
    {
        id: 6,
        icon: 'el-icon-help',
        title: '志愿者管理',
        index: 'VolunteerManage',
        subs: [
            {
                id: 61,
                icon: 'el-icon-tickets',
                title: '志愿者服务工单',
                index: 'inspectOrderlist'
            },
            {
                id: 62,
                icon: 'el-icon-service',
                title: '志愿者列表',
                index: 'volunteerlist'
            },
            {
                id: 63,
                icon: 'el-icon-notebook-2',
                title: '志愿者服务列表',
                index: 'volunteerservicelist'
            },
            {
                id: 64,
                icon: 'el-icon-present',
                title: '礼品兑换',
                index: 'volunteergiftsRecord'
            }
        ]
    },
    {
        icon: 'el-icon-truck',
        title: '物资管理',
        id: 7,
        index: 'WuziManage',
        subs: [
            {
                icon: 'el-icon-box',
                title: '物资项目管理',
                id: 71,
                index: 'StorageCatalogManage'
            },
            {
                icon: 'el-icon-shopping-cart-full',
                title: '物资库存表',
                id: 72,
                index: 'StorageStockManage'
            },
            {
                icon: 'el-icon-sell',
                title: '物资入库表',
                id: 73,
                index: 'StorageInTable'
            },
            {
                icon: 'el-icon-sold-out',
                title: '物资出库表',
                id: 74,
                index: 'StorageOutTable'
            },
            {
                icon: 'el-icon-document-checked',
                title: '物资消杀登记',
                id: 75,
                index: 'WuZiResign'
            }
        ]
    },
    {
        icon: 'el-icon-data-line',
        title: '健康监测管理',
        id: 18,
        index: 'healthDeviceHome',
        subs: [
            {
                icon: 'el-icon-lx-wifi',
                title: '体征监测雷达',
                id: 181,
                index: 'healthRadarList'
            },
            {
                icon: 'el-icon-c-scale-to-original',
                title: '睡眠监测带',
                id: 182,
                index: 'SleepMattresslist'
            },
            {
                icon: 'el-icon-lx-wifi',
                title: '生命体征监测仪',
                id: 189,
                index: 'qlRadarList'
            },
            {
                icon: 'el-icon-watch-1',
                title: '智能手环',
                id: 183,
                index: 'bracelet'
            },
            {
                icon: 'el-icon-finished',
                title: '4G智能拐杖',
                id: 1831,
                index: 'cane'
            },
            {
                icon: 'el-icon-bangzhu',
                title: '多功能检测仪',
                id: 184,
                index: 'Followlist'
            },
            {
                icon: 'el-icon-toilet-paper',
                title: '4G血压计',
                id: 185,
                index: 'BloodPressList'
            },
            {
                icon: 'el-icon-watch',
                title: '孝心环',
                id: 186,
                index: 'Watchlist'
            },
            {
                icon: 'el-icon-monitor',
                title: '体检一体机',
                id: 187,
                index: 'physicalList'
            }
        ]
    },
    {
        id: 8,
        icon: 'el-icon-set-up',
        title: '智慧养老',
        index: 'IntelligentManage',
        subs: [
            {
                icon: 'el-icon-data-board',
                title: '智能看护设备总览',
                id: 80,
                index: 'device/intellect-overview'
            },
            {
                icon: 'el-icon-phone-outline',
                title: '告警记录管理',
                id: 81,
                index: 'Alarmlog'
            },
            {
                icon: 'el-icon-data-board',
                title: '智能魔盒',
                id: 82,
                index: 'MagicBox'
            },
            {
                icon: 'el-icon-lx-link',
                title: '4G呼叫网关',
                id: 72,
                index: 'CallGateWayDeviceList'
            },
            {
                icon: 'el-icon-thumb',
                title: '无线呼叫按钮',
                id: 73,
                index: 'AnniuDeviceList'
            },
            {
                icon: 'el-icon-help',
                title: '跌倒设备管理',
                id: 83,
                index: 'fallManage',
                subs: [
                    {
                        icon: 'el-icon-lx-wifi',
                        title: '跌倒雷达',
                        id: 831,
                        index: 'FallRadarList'
                    },
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '毫米波跌倒检测仪',
                        id: 643,
                        index: 'QLFallRadarlist'
                    },
                    {
                        icon: 'el-icon-camera',
                        title: '奥瞳摄像头',
                        id: 832,
                        index: 'AotongCamera'
                    }
                ]
            },
            {
                icon: 'el-icon-video-camera',
                title: '监控管理',
                id: 82,
                index: 'camera',
                subs: [
                    {
                        icon: 'el-icon-video-camera',
                        title: '萤石云摄像头',
                        id: 821,
                        index: 'YsCamera'
                    },
                    {
                        icon: 'el-icon-video-camera',
                        title: '萤石猫眼',
                        id: 823,
                        index: 'YsPeephole‌'
                    },
                    {
                        icon: 'el-icon-video-camera',
                        title: '电信摄像头',
                        id: 822,
                        index: 'DxCamera'
                    }
                ]
            },
            {
                icon: 'el-icon-umbrella',
                title: '安防设备管理',
                id: 88,
                index: 'safetyManagement',
                subs: [
                    {
                        icon: 'el-icon-magic-stick',
                        title: '红外感应器',
                        id: 881,
                        index: 'LnfraredLnductor'
                    },
                    {
                        icon: 'el-icon-thumb',
                        title: '紧急呼叫器',
                        id: 882,
                        index: 'UrgencyBeeper'
                    },
                    {
                        icon: 'el-icon-cloudy-and-sunny',
                        title: '烟雾报警器',
                        id: 883,
                        index: 'SmogAlertor'
                    },
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '门窗感应器',
                        id: 884,
                        index: 'MagneticLnductor'
                    },
                    {
                        icon: 'el-icon-water-cup',
                        title: '燃气报警器',
                        id: 885,
                        index: 'FuelAlertor'
                    },
                    {
                        icon: 'el-icon-light-rain',
                        title: '水溢传感器',
                        id: 886,
                        index: 'overflowAlertor'
                    }
                ]
            },
            {
                icon: 'el-icon-files',
                title: '设备管理',
                id: 891,
                index: 'deviceManager'
            }
        ]
    },
    {
        icon: 'el-icon-setting',
        title: '系统设置',
        id: 9,
        index: 'SetManagement',
        subs: [
            {
                icon: 'el-icon-office-building',
                title: '机构介绍',
                id: 91,
                index: 'GroupInfo'
            },
            {
                icon: 'el-icon-postcard',
                title: '信息发布',
                id: 92,
                index: 'InformationMassagePush'
            },
            {
                icon: 'el-icon-medal-1',
                title: '活动发布',
                id: 93,
                index: 'ActiveList'
            },
            {
                icon: 'el-icon-printer',
                title: '数据字典',
                id: 94,
                index: 'Dictionary'
            },
            {
                icon: 'el-icon-user',
                title: '自理等级',
                id: 945,
                index: 'LevelCareManage'
            },
            {
                icon: 'el-icon-collection',
                title: '评估项目管理',
                id: 95,
                index: 'EvaluationList'
            },
            {
                icon: 'el-icon-set-up',
                title: '机构阈值管理',
                id: 96,
                index: 'GroupThresholdSetting'
            },
            {
                icon: 'el-icon-service',
                title: '娱乐管理',
                id: 97,
                index: 'entertainmentManagement'
            },
            {
                icon: 'el-icon-collection-tag',
                title: '版本管理',
                id: 98,
                index: 'VersionInfo'
            }
        ]
    }
];

//食堂菜单
export const canteenList = [
    {
        id: 1,
        icon: 'el-icon-data-line',
        title: '食堂首页',
        index: 'canteenMain'
    },
    {
        id: 2,
        icon: 'el-icon-office-building',
        title: '食堂管理',
        index: 'SiteManagement',
        subs: [
            {
                icon: 'el-icon-document',
                title: '基础信息',
                id: 21,
                index: 'BaseInfo'
            },
            {
                icon: 'el-icon-lx-home',
                title: '员工账号管理',
                id: 11,
                index: 'Department'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '多功能室',
                id: 22,
                index: 'MultiRoomList'
            },
            {
                icon: 'el-icon-medal-1',
                title: '课程活动管理',
                id: 231,
                index: 'CourseManage'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '客流量统计',
                id: 23,
                index: 'SwipeCardRecord'
            },
            {
                icon: 'el-icon-office-building',
                title: '食堂介绍',
                id: 24,
                index: 'SiteInfo'
            },
            {
                icon: 'el-icon-postcard',
                title: '信息发布',
                id: 25,
                index: 'InformationMassagePush'
            },
            {
                icon: 'el-icon-medal-1',
                title: '活动发布',
                id: 26,
                index: 'ActiveList'
            },
            {
                icon: 'el-icon-medal-1',
                title: '便民查询',
                id: 27,
                index: 'ConvenientSearchPj'
            }
        ]
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 3,
        index: 'ResidentManager',
        subs: [
            {
                icon: 'el-icon-lx-addressbook',
                title: '长者信息',
                id: 31,
                index: 'ResidentManager'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '咨询接待',
                id: 32,
                index: 'AdmissionConsult'
            }
        ]
    },
    {
        icon: 'el-icon-food',
        title: '餐饮管理',
        id: 47,
        index: 'canyinManagement',
        subs: [
            {
                icon: 'el-icon-chicken',
                title: '食物管理',
                id: 471,
                index: 'FoodManagement'
            },
            {
                icon: 'el-icon-reading',
                title: '每周菜谱',
                id: 472,
                index: 'WeeklyMenu'
            },
            {
                icon: 'el-icon-knife-fork',
                title: '食品留样记录表',
                id: 473,
                index: 'FoodRetention'
            },
            {
                icon: 'el-icon-box',
                title: '物资项目管理',
                id: 474,
                index: 'FoodCatalogManage'
            },
            {
                icon: 'el-icon-shopping-cart-full',
                title: '物资库存表',
                id: 475,
                index: 'FoodStockManage'
            },
            {
                icon: 'el-icon-sell',
                title: '物资入库表',
                id: 476,
                index: 'FoodInTable'
            },
            {
                icon: 'el-icon-sold-out',
                title: '物资出库表',
                id: 477,
                index: 'FoodOutTable'
            }
        ]
    },
    {
        icon: 'el-icon-truck',
        title: '物资管理',
        id: 5,
        index: 'WuziManage',
        subs: [
            {
                icon: 'el-icon-box',
                title: '物资项目管理',
                id: 51,
                index: 'StorageCatalogManage'
            },
            {
                icon: 'el-icon-shopping-cart-full',
                title: '物资库存表',
                id: 52,
                index: 'StorageStockManage'
            },
            {
                icon: 'el-icon-sell',
                title: '物资入库表',
                id: 53,
                index: 'StorageInTable'
            },
            {
                icon: 'el-icon-sold-out',
                title: '物资出库表',
                id: 54,
                index: 'StorageOutTable'
            }
        ]
    }
];

//东西湖Admin
export const dxhAdmin = [
    {
        id: 1,
        icon: 'el-icon-office-building',
        title: '院务管理',
        index: 'SystemMain',
        subs: [
            {
                icon: 'el-icon-lx-home',
                title: '部门员工管理',
                id: 11,
                index: 'Department'
            },
            // {
            //     icon: 'el-icon-lx-punch',
            //     title: '员工考勤管理',
            //     id: 12,
            //     index: 'KaoqinView',
            // },
            {
                icon: 'el-icon-lx-service',
                title: '护工班组管理',
                id: 13,
                index: 'NursingManagement'
            },
            {
                icon: 'el-icon-school',
                title: '楼栋房间管理',
                id: 14,
                index: 'RoomBedManager',
                subs: [
                    {
                        icon: 'el-icon-office-building',
                        title: '楼栋管理',
                        id: 141,
                        index: 'BuildView'
                    },
                    {
                        icon: 'el-icon-house',
                        title: '房间管理',
                        id: 142,
                        index: 'RoomSetting'
                    },
                    {
                        icon: 'el-icon-folder',
                        title: '床位管理',
                        id: 143,
                        index: 'BedSetting'
                    },
                    {
                        id: 144,
                        index: 'RoomView',
                        title: '床位视图',
                        icon: 'el-icon-view'
                    },
                    {
                        icon: 'el-icon-link',
                        title: '床位重排',
                        id: 145,
                        index: 'BedRearrangement'
                    }
                ]
            },
            {
                icon: 'el-icon-edit',
                title: '工作安全日志',
                id: 15,
                index: 'WorkLogManage',
                subs: [
                    {
                        icon: 'el-icon-document',
                        title: '工作日志管理',
                        id: 151,
                        index: 'WorkLogList'
                    },
                    {
                        icon: 'el-icon-document',
                        title: '安全检查日志管理',
                        id: 153,
                        index: 'SafeLogList'
                    }
                ]
            },
            {
                icon: 'el-icon-view',
                title: '院内监控看板',
                id: 16,
                index: 'VideoView'
            }
        ]
    },
    {
        icon: 'el-icon-lx-group',
        title: '前台管理',
        id: 2,
        index: 'AdmissionOlderList',
        subs: [
            {
                icon: 'el-icon-lx-profile',
                title: '入院管理',
                id: 21,
                index: 'AdmissionManager',
                subs: [
                    {
                        icon: 'el-icon-refrigerator',
                        title: '预约咨询',
                        id: 211,
                        index: 'AdmissionConsult'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '取消预约',
                        id: 212,
                        index: 'AdmissionCancel'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '入院评估',
                        id: 213,
                        index: 'AdmissionPg'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '入院办理',
                        id: 214,
                        index: 'AdmissionOlderList'
                    }
                ]
            },
            {
                icon: 'el-icon-document',
                title: '合同管理',
                id: 24,
                index: 'ContractManage'
            },
            {
                icon: 'el-icon-date',
                title: '入院参观信息',
                id: 406,
                index: 'OldVisitTable'
            },
            {
                icon: 'el-icon-date',
                title: '预约登记表',
                id: 4061,
                index: 'OldReservationTable'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '院民出入登记表',
                id: 407,
                index: 'EldOutTable'
            },
            {
                icon: 'el-icon-lx-crown',
                title: '老人生日',
                id: 43,
                index: 'OldmanBirthday'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '出院办理',
                id: 4051,
                index: 'LeaveHistoryList'
            }
        ]
    },
    {
        icon: 'el-icon-lx-redpacket',
        title: '财务管理',
        id: 3,
        index: 'ChargeManagement',
        subs: [
            {
                icon: 'el-icon-data-analysis',
                title: '月度费用绘总',
                id: 31,
                index: 'MonthFinanceView'
            },
            {
                icon: 'el-icon-money',
                title: '月度应收账款',
                id: 312,
                index: 'MonthReceivableList'
            },
            {
                icon: 'el-icon-tickets',
                title: '费用记录单',
                id: 32,
                index: 'PaymentRecord'
            },
            {
                icon: 'el-icon-wallet',
                title: '消费记录',
                id: 323,
                index: 'ConsumptionRecord'
            },
            {
                icon: 'el-icon-money',
                title: '缴费审核记录',
                id: 324,
                index: 'RechargeRecord'
            },
            {
                icon: 'el-icon-lx-recharge',
                title: '余额管理',
                id: 34,
                index: 'ArrearageList'
            },
            {
                // FeeBindList
                icon: 'el-icon-money',
                title: '月度费用绑定清单',
                id: 342,
                index: 'FeeBindList'
            },
            {
                icon: 'el-icon-suitcase-1',
                title: '收费项目管理',
                id: 33,
                index: 'ChargeCategoryManagement'
            },
            {
                icon: 'el-icon-coordinate',
                title: '老人类别管理',
                id: 36,
                index: 'PersonCategoryManagement'
            },
            {
                icon: 'el-icon-money',
                title: '老人类别减免',
                id: 37,
                index: 'personCategoryReduction'
            }
        ]
    },
    {
        icon: 'el-icon-coordinate',
        title: '护理管理',
        id: 4,
        index: 'careManage',
        subs: [
            {
                icon: 'el-icon-date',
                title: '排班管理',
                id: 41,
                index: 'SchedulingManage',
                subs: [
                    {
                        icon: 'el-icon-date',
                        title: '护工排班方案',
                        id: 411,
                        index: 'NursingArrangePlan'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '排班计划审批',
                        id: 413,
                        index: 'SchedulingPlanApproval'
                    }
                ]
            },
            {
                icon: 'el-icon-notebook-2',
                title: '护理记录',
                id: 42,
                index: 'LifeServiceManagement',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '交班日志管理',
                        id: 422,
                        index: 'HandoverLogLook'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理日志管理',
                        id: 424,
                        index: 'NursingLogManagement'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '班长日志管理',
                        id: 426,
                        index: 'MonitorLogManagement'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '值班日志',
                        id: 427,
                        index: 'DutyLogList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '日常护理记录',
                        id: 428,
                        index: 'TableCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '特殊护理记录',
                        id: 429,
                        index: 'TableSpecialCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '长者护理记录',
                        id: 4210,
                        index: 'TableCareProject'
                    },
                ]
            },
            {
                icon: 'el-icon-notebook-2',
                title: '护理计划',
                id: 4211,
                index: 'CarePlanManage',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理项目管理',
                        id: 42112,
                        index: 'NursingProjectList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理模板管理',
                        id: 42113,
                        index: 'NursingTemplateList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理计划管理',
                        id: 42111,
                        index: 'CarePlanList'
                    },
                    {
                        icon: 'el-icon-user-solid',
                        title: '护理组管理',
                        id: 4220,
                        index: 'NursingGroupManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组增加',
                                id: 42201,
                                index: 'CareNursingGroupAdd'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组变更',
                                id: 42202,
                                index: 'CareNursingGroupChange'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组查询',
                                id: 42203,
                                index: 'CareNursingGroupQuery'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '班次设置',
                                id: 42204,
                                index: 'RoomShiftSetting'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '排班管理',
                                id: 42205,
                                index: 'RoomScheduleIndex'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-date',
                        title: '护理任务管理',
                        id: 4230,
                        index: 'NursingTaskManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务自动生成',
                                id: 42301,
                                index: 'CareNursingTaskGenerate'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务监控',
                                id: 42302,
                                index: 'CareNursingTaskMonitor'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务执行打卡',
                                id: 42303,
                                index: 'CareNursingTaskPunch'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '超时预警',
                                id: 42304,
                                index: 'CareNursingTaskTimeout'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '异常上报',
                                id: 42305,
                                index: 'CareNursingTaskException'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-document',
                        title: '护理记录管理',
                        id: 4240,
                        index: 'CareNursingRecordView'
                    },
                    {
                        icon: 'el-icon-connection',
                        title: '整合查看',
                        id: 4250,
                        index: 'NursingIntegrateReport'
                    },
                    {
                        icon: 'el-icon-data-line',
                        title: '数据统计',
                        id: 4260,
                        index: 'NursingStatsDashboard'
                    },
                    {
                        icon: 'el-icon-money',
                        title: '护理计费',
                        id: 4270,
                        index: 'NursingBillList'
                    }
                ]
            },

            {
                icon: 'el-icon-lx-forward',
                title: '老人请假',
                id: 44,
                index: 'OldmanLeave'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '体检记录',
                id: 48,
                index: 'MedicalCare'
            },
            {
                icon: 'el-icon-guide',
                title: '调房调级',
                id: 45,
                index: 'ReviseRecordList',
                subs: [
                    {
                        icon: 'el-icon-guide',
                        title: '调房调级审批',
                        id: 453,
                        index: 'changeFeeRootList'
                    }
                ]
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '用药管理',
                id: 46,
                index: 'MedicalManage',
                subs: [
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '用药记录',
                        id: 461,
                        index: 'PharmacyRecord'
                    },
                    {
                        icon: 'el-icon-document',
                        title: '历史用药记录',
                        id: 462,
                        index: 'PharmacyHistoryRecord'
                    },
                    {
                        icon: 'el-icon-attract',
                        title: '用药计划',
                        id: 463,
                        index: 'MedicalPlanList'
                    }
                ]
            }
        ]
    },
    {
        icon: 'el-icon-food',
        title: '餐饮管理',
        id: 47,
        index: 'canyinManagement',
        subs: [
            {
                icon: 'el-icon-chicken',
                title: '食物管理',
                id: 471,
                index: 'FoodManagement'
            },
            {
                icon: 'el-icon-reading',
                title: '每周菜谱',
                id: 472,
                index: 'WeeklyMenu'
            },
            {
                icon: 'el-icon-knife-fork',
                title: '食品留样记录表',
                id: 473,
                index: 'FoodRetention'
            },
            {
                icon: 'el-icon-box',
                title: '物资项目管理',
                id: 474,
                index: 'FoodCatalogManage'
            },
            {
                icon: 'el-icon-shopping-cart-full',
                title: '物资库存表',
                id: 475,
                index: 'FoodStockManage'
            },
            {
                icon: 'el-icon-sell',
                title: '物资入库表',
                id: 476,
                index: 'FoodInTable'
            },
            {
                icon: 'el-icon-sold-out',
                title: '物资出库表',
                id: 477,
                index: 'FoodOutTable'
            }
        ]
    },
    {
        icon: 'el-icon-truck',
        title: '物资管理',
        id: 5,
        index: 'WuziManage',
        subs: [
            {
                icon: 'el-icon-box',
                title: '物资项目管理',
                id: 51,
                index: 'StorageCatalogManage'
            },
            {
                icon: 'el-icon-shopping-cart-full',
                title: '物资库存表',
                id: 52,
                index: 'StorageStockManage'
            },
            {
                icon: 'el-icon-sell',
                title: '物资入库表',
                id: 53,
                index: 'StorageInTable'
            },
            {
                icon: 'el-icon-sold-out',
                title: '物资出库表',
                id: 54,
                index: 'StorageOutTable'
            },
            {
                icon: 'el-icon-document-checked',
                title: '物资消杀登记',
                id: 55,
                index: 'WuZiResign'
            }
        ]
    },
    {
        icon: 'el-icon-data-line',
        title: '健康监测管理',
        id: 6,
        index: 'healthDeviceHome',
        subs: [
            {
                icon: 'el-icon-lx-wifi',
                title: '体征监测雷达',
                id: 61,
                index: 'healthRadarList'
            },
            {
                icon: 'el-icon-c-scale-to-original',
                title: '睡眠监测带',
                id: 62,
                index: 'SleepMattresslist'
            },
            {
                icon: 'el-icon-watch-1',
                title: '智能手环',
                id: 63,
                index: 'bracelet'
            },
            {
                icon: 'el-icon-finished',
                title: '4G智能拐杖',
                id: 693,
                index: 'cane'
            },
            {
                icon: 'el-icon-bangzhu',
                title: '多功能检测仪',
                id: 64,
                index: 'Followlist'
            },
            {
                icon: 'el-icon-toilet-paper',
                title: '4G血压计',
                id: 65,
                index: 'BloodPressList'
            },
            {
                icon: 'el-icon-watch',
                title: '孝心环',
                id: 66,
                index: 'Watchlist'
            },
            {
                icon: 'el-icon-monitor',
                title: '体检一体机',
                id: 67,
                index: 'physicalList'
            },
            {
                icon: 'el-icon-folder',
                title: '床位数据看板',
                id: 68,
                index: 'BedRadarManagement'
            }
        ]
    },
    {
        icon: 'el-icon-phone-outline',
        title: '应急呼叫管理',
        id: 7,
        index: 'Alarmlog',
        subs: [
            {
                icon: 'el-icon-phone-outline',
                title: '告警记录管理',
                id: 70,
                index: 'Alarmlog'
            },
            {
                icon: 'el-icon-thumb',
                title: '无线呼叫按钮',
                id: 73,
                index: 'AnniuDeviceList'
            },
            {
                icon: 'el-icon-data-board',
                title: '智能魔盒',
                id: 71,
                index: 'MagicBox'
            },
            {
                icon: 'el-icon-lx-link',
                title: '4G呼叫网关',
                id: 72,
                index: 'CallGateWayDeviceList'
            }
        ]
    },
    {
        icon: 'el-icon-set-up',
        title: '智能设备管理',
        id: 8,
        index: 'IntelligentManage',
        subs: [
            {
                icon: 'el-icon-data-board',
                title: '智能看护设备总览',
                id: 80,
                index: 'device/intellect-overview'
            },
            {
                icon: 'el-icon-aim',
                title: '巡更管理',
                id: 84,
                index: 'PatrolManagement',
                subs: [
                    {
                        icon: 'el-icon-mobile',
                        title: '巡更棒管理',
                        id: 841,
                        index: 'PatrollingRod'
                    },
                    {
                        icon: 'el-icon-help',
                        title: '巡更点管理',
                        id: 842,
                        index: 'PatrolPoints'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '巡更记录',
                        id: 843,
                        index: 'PatrollingRecord'
                    },
                    {
                        icon: 'el-icon-s-tools',
                        title: '巡更设置',
                        id: 844,
                        index: 'PatrollingSeting'
                    },
                    {
                        icon: 'el-icon-water-cup',
                        title: '巡更提醒',
                        id: 845,
                        index: 'PatrolReminder'
                    },
                    {
                        icon: 'el-icon-data-analysis',
                        title: '巡更看板',
                        id: 846,
                        index: 'PatrolView'
                    }
                ]
            },
            {
                icon: 'el-icon-video-camera',
                title: '萤石云监控',
                id: 82,
                index: 'camera'
            },
            {
                icon: 'el-icon-umbrella',
                title: '安防设备管理',
                id: 85,
                index: 'safetyManagement',
                subs: [
                    {
                        icon: 'el-icon-magic-stick',
                        title: '红外感应器',
                        id: 851,
                        index: 'LnfraredLnductor'
                    },
                    {
                        icon: 'el-icon-thumb',
                        title: '紧急呼叫器',
                        id: 852,
                        index: 'UrgencyBeeper'
                    },
                    {
                        icon: 'el-icon-cloudy-and-sunny',
                        title: '烟雾报警器',
                        id: 853,
                        index: 'SmogAlertor'
                    },
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '门窗传感器',
                        id: 854,
                        index: 'MagneticLnductor'
                    },
                    {
                        icon: 'el-icon-water-cup',
                        title: '燃气报警器',
                        id: 855,
                        index: 'FuelAlertor'
                    },
                    {
                        icon: 'el-icon-light-rain',
                        title: '溢水报警器',
                        id: 856,
                        index: 'overflowAlertor'
                    }
                ]
            },
            {
                icon: 'el-icon-thumb',
                title: '考勤打卡机管理',
                id: 86,
                index: 'attendanceList'
            },
            {
                icon: 'el-icon-house',
                title: '门禁管理',
                id: 81,
                index: 'doorManagement',
                subs: [
                    {
                        icon: 'el-icon-suitcase',
                        title: '门禁读卡器',
                        id: 811,
                        index: 'cardlist'
                    },
                    {
                        icon: 'el-icon-c-scale-to-original',
                        title: '门禁卡',
                        id: 812,
                        index: 'accesslist'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '出入记录',
                        id: 813,
                        index: 'DoorAllRecord'
                    },
                    {
                        icon: 'el-icon-c-scale-to-original',
                        title: '门禁控制卡',
                        id: 814,
                        index: 'AccessControlCard'
                    },
                    {
                        icon: 'el-icon-receiving',
                        title: '门禁卡权限',
                        id: 815,
                        index: 'AccessAuthority'
                    }
                ]
            },
            {
                icon: 'el-icon-help',
                title: '跌倒设备管理',
                id: 83,
                index: 'fallManage',
                subs: [
                    {
                        icon: 'el-icon-lx-wifi',
                        title: '跌倒雷达',
                        id: 831,
                        index: 'FallRadarList'
                    },
                    {
                        icon: 'el-icon-camera',
                        title: '奥瞳摄像头',
                        id: 832,
                        index: 'AotongCamera'
                    }
                ]
            },
            {
                icon: 'el-icon-set-up',
                title: '智能电表管理',
                id: 871,
                index: 'eMeterList'
            },
            {
                icon: 'el-icon-receiving',
                title: '智能水表管理',
                id: 872,
                index: 'wMeterList'
            },
            {
                icon: 'el-icon-ice-cream-square',
                title: '无线网卡管理',
                id: 87,
                index: 'wifiDeviceList'
            },
            {
                icon: 'el-icon-files',
                title: '设备管理',
                id: 88,
                index: 'deviceManager'
            }
        ]
    },
    {
        icon: 'el-icon-setting',
        title: '系统设置',
        id: 9,
        index: 'SetManagement',
        subs: [
            {
                icon: 'el-icon-office-building',
                title: '机构介绍',
                id: 91,
                index: 'GroupInfo'
            },
            {
                icon: 'el-icon-postcard',
                title: '信息发布',
                id: 92,
                index: 'InformationMassagePush'
            },
            {
                icon: 'el-icon-medal-1',
                title: '活动发布',
                id: 93,
                index: 'ActiveList'
            },
            {
                icon: 'el-icon-printer',
                title: '数据字典',
                id: 94,
                index: 'Dictionary'
            },
            {
                icon: 'el-icon-user',
                title: '自理等级',
                id: 945,
                index: 'LevelCareManage'
            },
            {
                icon: 'el-icon-collection-tag',
                title: '版本管理',
                id: 98,
                index: 'VersionInfo'
            }
        ]
    }
];

//机构的服务部长
export const groupServer = [
    {
        id: 1,
        icon: 'el-icon-office-building',
        title: '院务管理',
        index: 'SystemMain',
        subs: [
            {
                icon: 'el-icon-lx-service',
                title: '护工班组管理',
                id: 13,
                index: 'NursingManagement'
            },
            // {
            //     icon: 'el-icon-lx-punch',
            //     title: '员工考勤管理',
            //     id: 12,
            //     index: 'KaoqinView',
            // },
            {
                icon: 'el-icon-school',
                title: '楼栋房间管理',
                id: 14,
                index: 'RoomBedManager',
                subs: [
                    {
                        icon: 'el-icon-office-building',
                        title: '楼栋管理',
                        id: 141,
                        index: 'BuildView'
                    },
                    {
                        icon: 'el-icon-house',
                        title: '房间管理',
                        id: 142,
                        index: 'RoomSetting'
                    },
                    {
                        icon: 'el-icon-folder',
                        title: '床位管理',
                        id: 143,
                        index: 'BedSetting'
                    },
                    {
                        id: 144,
                        index: 'RoomView',
                        title: '床位视图',
                        icon: 'el-icon-view'
                    },
                    {
                        icon: 'el-icon-link',
                        title: '床位重排',
                        id: 145,
                        index: 'BedRearrangement'
                    }
                ]
            },
            {
                icon: 'el-icon-view',
                title: '院内监控看板',
                id: 16,
                index: 'VideoView'
            }
        ]
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 2,
        index: 'AdmissionOlderList',
        subs: [
            {
                icon: 'el-icon-lx-profile',
                title: '入院管理',
                id: 21,
                index: 'AdmissionManager',
                subs: [
                    {
                        icon: 'el-icon-refrigerator',
                        title: '预约咨询',
                        id: 211,
                        index: 'AdmissionConsult'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '取消预约',
                        id: 212,
                        index: 'AdmissionCancel'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '入院评估',
                        id: 213,
                        index: 'AdmissionPg'
                    },
                    {
                        icon: 'el-icon-refrigerator',
                        title: '入院办理',
                        id: 214,
                        index: 'AdmissionOlderList'
                    }
                ]
            },
            {
                icon: 'el-icon-document',
                title: '合同管理',
                id: 24,
                index: 'ContractManage'
            }
        ]
    },
    {
        icon: 'el-icon-coordinate',
        title: '护理管理',
        id: 4,
        index: 'careManage',
        subs: [
            {
                icon: 'el-icon-date',
                title: '排班管理',
                id: 41,
                index: 'SchedulingManage',
                subs: [
                    {
                        icon: 'el-icon-date',
                        title: '护工排班方案',
                        id: 411,
                        index: 'NursingArrangePlan'
                    },
                    {
                        icon: 'el-icon-date',
                        title: '排班计划审批',
                        id: 413,
                        index: 'SchedulingPlanApproval'
                    }
                ]
            },
            {
                icon: 'el-icon-notebook-2',
                title: '护理记录',
                id: 42,
                index: 'LifeServiceManagement',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '交班日志管理',
                        id: 422,
                        index: 'HandoverLogLook'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理日志管理',
                        id: 424,
                        index: 'NursingLogManagement'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '班长日志管理',
                        id: 426,
                        index: 'MonitorLogManagement'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '值班日志',
                        id: 427,
                        index: 'DutyLogList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '日常护理记录',
                        id: 428,
                        index: 'TableCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '特殊护理记录',
                        id: 429,
                        index: 'TableSpecialCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '长者护理记录',
                        id: 4210,
                        index: 'TableCareProject'
                    },
                ]
            },
            {
                icon: 'el-icon-notebook-2',
                title: '护理计划',
                id: 4211,
                index: 'CarePlanManage',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理项目管理',
                        id: 42112,
                        index: 'NursingProjectList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理模板管理',
                        id: 42113,
                        index: 'NursingTemplateList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理计划管理',
                        id: 42111,
                        index: 'CarePlanList'
                    },
                    {
                        icon: 'el-icon-user-solid',
                        title: '护理组管理',
                        id: 4220,
                        index: 'NursingGroupManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组增加',
                                id: 42201,
                                index: 'CareNursingGroupAdd'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组变更',
                                id: 42202,
                                index: 'CareNursingGroupChange'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组查询',
                                id: 42203,
                                index: 'CareNursingGroupQuery'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '班次设置',
                                id: 42204,
                                index: 'RoomShiftSetting'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '排班管理',
                                id: 42205,
                                index: 'RoomScheduleIndex'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-date',
                        title: '护理任务管理',
                        id: 4230,
                        index: 'NursingTaskManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务自动生成',
                                id: 42301,
                                index: 'CareNursingTaskGenerate'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务监控',
                                id: 42302,
                                index: 'CareNursingTaskMonitor'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务执行打卡',
                                id: 42303,
                                index: 'CareNursingTaskPunch'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '超时预警',
                                id: 42304,
                                index: 'CareNursingTaskTimeout'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '异常上报',
                                id: 42305,
                                index: 'CareNursingTaskException'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-document',
                        title: '护理记录管理',
                        id: 4240,
                        index: 'CareNursingRecordView'
                    },
                    {
                        icon: 'el-icon-connection',
                        title: '整合查看',
                        id: 4250,
                        index: 'NursingIntegrateReport'
                    },
                    {
                        icon: 'el-icon-data-line',
                        title: '数据统计',
                        id: 4260,
                        index: 'NursingStatsDashboard'
                    },
                    {
                        icon: 'el-icon-money',
                        title: '护理计费',
                        id: 4270,
                        index: 'NursingBillList'
                    }
                ]
            },
            {
                icon: 'el-icon-date',
                title: '入院参观信息',
                id: 406,
                index: 'OldVisitTable'
            },
            {
                icon: 'el-icon-date',
                title: '预约登记表',
                id: 4061,
                index: 'OldReservationTable'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '院民出入登记表',
                id: 407,
                index: 'EldOutTable'
            },
            {
                icon: 'el-icon-lx-crown',
                title: '老人生日',
                id: 43,
                index: 'OldmanBirthday'
            },
            {
                icon: 'el-icon-lx-forward',
                title: '老人请假',
                id: 44,
                index: 'OldmanLeave'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '体检记录',
                id: 48,
                index: 'MedicalCare'
            },
            {
                icon: 'el-icon-guide',
                title: '调房调级审批',
                id: 453,
                index: 'changeFeeRootList'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '出院办理',
                id: 4051,
                index: 'LeaveHistoryList'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '用药管理',
                id: 46,
                index: 'MedicalManage',
                subs: [
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '用药记录',
                        id: 461,
                        index: 'PharmacyRecord'
                    },
                    {
                        icon: 'el-icon-document',
                        title: '历史用药记录',
                        id: 462,
                        index: 'PharmacyHistoryRecord'
                    },
                    {
                        icon: 'el-icon-attract',
                        title: '用药计划',
                        id: 463,
                        index: 'MedicalPlanList'
                    }
                ]
            },
            {
                icon: 'el-icon-food',
                title: '餐饮管理',
                id: 47,
                index: 'canyinManagement',
                subs: [
                    {
                        icon: 'el-icon-chicken',
                        title: '食物管理',
                        id: 471,
                        index: 'FoodManagement'
                    },
                    {
                        icon: 'el-icon-reading',
                        title: '每周菜谱',
                        id: 472,
                        index: 'WeeklyMenu'
                    },
                    {
                        icon: 'el-icon-knife-fork',
                        title: '食品留样记录表',
                        id: 473,
                        index: 'FoodRetention'
                    },
                    {
                        icon: 'el-icon-box',
                        title: '物资项目管理',
                        id: 474,
                        index: 'FoodCatalogManage'
                    },
                    {
                        icon: 'el-icon-shopping-cart-full',
                        title: '物资库存表',
                        id: 475,
                        index: 'FoodStockManage'
                    },
                    {
                        icon: 'el-icon-sell',
                        title: '物资入库表',
                        id: 476,
                        index: 'FoodInTable'
                    },
                    {
                        icon: 'el-icon-sold-out',
                        title: '物资出库表',
                        id: 477,
                        index: 'FoodOutTable'
                    }
                ]
            }
        ]
    },
    {
        icon: 'el-icon-truck',
        title: '物资管理',
        id: 5,
        index: 'WuziManage',
        subs: [
            {
                icon: 'el-icon-box',
                title: '物资项目管理',
                id: 51,
                index: 'StorageCatalogManage'
            },
            {
                icon: 'el-icon-shopping-cart-full',
                title: '物资库存表',
                id: 52,
                index: 'StorageStockManage'
            },
            {
                icon: 'el-icon-sell',
                title: '物资入库表',
                id: 53,
                index: 'StorageInTable'
            },
            {
                icon: 'el-icon-sold-out',
                title: '物资出库表',
                id: 54,
                index: 'StorageOutTable'
            },
            {
                icon: 'el-icon-document-checked',
                title: '物资消杀登记',
                id: 55,
                index: 'WuZiResign'
            }
        ]
    },
    {
        icon: 'el-icon-data-line',
        title: '健康监测管理',
        id: 6,
        index: 'healthDeviceHome',
        subs: [
            {
                icon: 'el-icon-lx-wifi',
                title: '体征监测雷达',
                id: 61,
                index: 'healthRadarList'
            },
            {
                icon: 'el-icon-c-scale-to-original',
                title: '睡眠监测带',
                id: 62,
                index: 'SleepMattresslist'
            },
            {
                icon: 'el-icon-watch-1',
                title: '智能手环',
                id: 63,
                index: 'bracelet'
            },
            {
                icon: 'el-icon-finished',
                title: '4G智能拐杖',
                id: 693,
                index: 'cane'
            },
            {
                icon: 'el-icon-bangzhu',
                title: '多功能检测仪',
                id: 64,
                index: 'Followlist'
            },
            {
                icon: 'el-icon-toilet-paper',
                title: '4G血压计',
                id: 65,
                index: 'BloodPressList'
            },
            {
                icon: 'el-icon-watch',
                title: '孝心环',
                id: 66,
                index: 'Watchlist'
            },
            {
                icon: 'el-icon-monitor',
                title: '体检一体机',
                id: 67,
                index: 'physicalList'
            },
            {
                icon: 'el-icon-folder',
                title: '床位数据看板',
                id: 68,
                index: 'BedRadarManagement'
            }
        ]
    },
    {
        icon: 'el-icon-phone-outline',
        title: '应急呼叫管理',
        id: 7,
        index: 'Alarmlog',
        subs: [
            {
                icon: 'el-icon-phone-outline',
                title: '告警记录管理',
                id: 70,
                index: 'Alarmlog'
            },
            {
                icon: 'el-icon-data-board',
                title: '智能魔盒',
                id: 71,
                index: 'MagicBox'
            },
            {
                icon: 'el-icon-lx-link',
                title: '4G呼叫网关',
                id: 72,
                index: 'CallGateWayDeviceList'
            },
            {
                icon: 'el-icon-thumb',
                title: '无线呼叫按钮',
                id: 73,
                index: 'AnniuDeviceList'
            }
        ]
    },
    {
        icon: 'el-icon-set-up',
        title: '智能设备管理',
        id: 8,
        index: 'IntelligentManage',
        subs: [
            {
                icon: 'el-icon-data-board',
                title: '智能看护设备总览',
                id: 80,
                index: 'device/intellect-overview'
            },
            {
                icon: 'el-icon-aim',
                title: '巡更管理',
                id: 84,
                index: 'PatrolManagement',
                subs: [
                    {
                        icon: 'el-icon-mobile',
                        title: '巡更棒管理',
                        id: 841,
                        index: 'PatrollingRod'
                    },
                    {
                        icon: 'el-icon-help',
                        title: '巡更点管理',
                        id: 842,
                        index: 'PatrolPoints'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '巡更记录',
                        id: 843,
                        index: 'PatrollingRecord'
                    },
                    {
                        icon: 'el-icon-s-tools',
                        title: '巡更设置',
                        id: 844,
                        index: 'PatrollingSeting'
                    },
                    {
                        icon: 'el-icon-water-cup',
                        title: '巡更提醒',
                        id: 845,
                        index: 'PatrolReminder'
                    }
                ]
            },
            {
                icon: 'el-icon-data-analysis',
                title: '巡更看板',
                id: 846,
                index: 'PatrolView'
            },
            {
                icon: 'el-icon-house',
                title: '门禁管理',
                id: 81,
                index: 'doorManagement',
                subs: [
                    {
                        icon: 'el-icon-suitcase',
                        title: '门禁读卡器',
                        id: 811,
                        index: 'cardlist'
                    },
                    {
                        icon: 'el-icon-c-scale-to-original',
                        title: '门禁卡',
                        id: 812,
                        index: 'accesslist'
                    },
                    {
                        icon: 'el-icon-tickets',
                        title: '出入记录',
                        id: 813,
                        index: 'DoorAllRecord'
                    },
                    {
                        icon: 'el-icon-c-scale-to-original',
                        title: '门禁控制卡',
                        id: 814,
                        index: 'AccessControlCard'
                    },
                    {
                        icon: 'el-icon-receiving',
                        title: '门禁卡权限',
                        id: 815,
                        index: 'AccessAuthority'
                    }
                ]
            },
            {
                icon: 'el-icon-video-camera',
                title: '萤石云监控',
                id: 82,
                index: 'camera'
            },
            {
                icon: 'el-icon-help',
                title: '跌倒设备管理',
                id: 83,
                index: 'fallManage',
                subs: [
                    {
                        icon: 'el-icon-lx-wifi',
                        title: '跌倒雷达',
                        id: 831,
                        index: 'FallRadarList'
                    },
                    {
                        icon: 'el-icon-camera',
                        title: '奥瞳摄像头',
                        id: 832,
                        index: 'AotongCamera'
                    }
                ]
            },
            {
                icon: 'el-icon-umbrella',
                title: '安防设备管理',
                id: 85,
                index: 'safetyManagement',
                subs: [
                    {
                        icon: 'el-icon-magic-stick',
                        title: '红外感应器',
                        id: 851,
                        index: 'LnfraredLnductor'
                    },
                    {
                        icon: 'el-icon-thumb',
                        title: '紧急呼叫器',
                        id: 852,
                        index: 'UrgencyBeeper'
                    },
                    {
                        icon: 'el-icon-cloudy-and-sunny',
                        title: '烟雾报警器',
                        id: 853,
                        index: 'SmogAlertor'
                    },
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '门窗传感器',
                        id: 854,
                        index: 'MagneticLnductor'
                    },
                    {
                        icon: 'el-icon-water-cup',
                        title: '燃气报警器',
                        id: 855,
                        index: 'FuelAlertor'
                    },
                    {
                        icon: 'el-icon-light-rain',
                        title: '溢水报警器',
                        id: 856,
                        index: 'overflowAlertor'
                    }
                ]
            },
            {
                icon: 'el-icon-thumb',
                title: '考勤打卡机管理',
                id: 86,
                index: 'attendanceList'
            },
            {
                icon: 'el-icon-files',
                title: '设备管理',
                id: 88,
                index: 'deviceManager'
            }
        ]
    },
    {
        icon: 'el-icon-setting',
        title: '系统设置',
        id: 9,
        index: 'SetManagement',
        subs: [
            {
                icon: 'el-icon-office-building',
                title: '机构介绍',
                id: 91,
                index: 'GroupInfo'
            },
            {
                icon: 'el-icon-postcard',
                title: '信息发布',
                id: 92,
                index: 'InformationMassagePush'
            },
            {
                icon: 'el-icon-medal-1',
                title: '活动发布',
                id: 93,
                index: 'ActiveList'
            },
            {
                icon: 'el-icon-printer',
                title: '数据字典',
                id: 94,
                index: 'Dictionary'
            },
            {
                icon: 'el-icon-user',
                title: '自理等级',
                id: 945,
                index: 'LevelCareManage'
            }
        ]
    }
];

//机构的后勤部
export const groupLogistics = [
    {
        id: 1,
        icon: 'el-icon-office-building',
        title: '院务管理',
        index: 'SystemMain'
    },
    {
        icon: 'el-icon-food',
        title: '餐饮管理',
        id: 4,
        index: 'canyinManagement',
        subs: [
            {
                icon: 'el-icon-chicken',
                title: '食物管理',
                id: 471,
                index: 'FoodManagement'
            },
            {
                icon: 'el-icon-reading',
                title: '每周菜谱',
                id: 472,
                index: 'WeeklyMenu'
            },
            {
                icon: 'el-icon-knife-fork',
                title: '食品留样记录表',
                id: 473,
                index: 'FoodRetention'
            },
            {
                icon: 'el-icon-box',
                title: '物资项目管理',
                id: 474,
                index: 'FoodCatalogManage'
            },
            {
                icon: 'el-icon-shopping-cart-full',
                title: '物资库存表',
                id: 475,
                index: 'FoodStockManage'
            },
            {
                icon: 'el-icon-sell',
                title: '物资入库表',
                id: 476,
                index: 'FoodInTable'
            },
            {
                icon: 'el-icon-sold-out',
                title: '物资出库表',
                id: 477,
                index: 'FoodOutTable'
            }
        ]
    },
    {
        icon: 'el-icon-truck',
        title: '物资管理',
        id: 5,
        index: 'WuziManage',
        subs: [
            {
                icon: 'el-icon-box',
                title: '物资项目管理',
                id: 51,
                index: 'StorageCatalogManage'
            },
            {
                icon: 'el-icon-shopping-cart-full',
                title: '物资库存表',
                id: 52,
                index: 'StorageStockManage'
            },
            {
                icon: 'el-icon-sell',
                title: '物资入库表',
                id: 53,
                index: 'StorageInTable'
            },
            {
                icon: 'el-icon-sold-out',
                title: '物资出库表',
                id: 54,
                index: 'StorageOutTable'
            },
            {
                icon: 'el-icon-document-checked',
                title: '物资消杀登记',
                id: 55,
                index: 'WuZiResign'
            }
        ]
    },
    {
        icon: 'el-icon-aim',
        title: '巡更管理',
        id: 8,
        index: 'PatrolManagement',
        subs: [
            {
                icon: 'el-icon-tickets',
                title: '巡更记录',
                id: 843,
                index: 'PatrollingRecord'
            },
            {
                icon: 'el-icon-water-cup',
                title: '巡更提醒',
                id: 845,
                index: 'PatrolReminder'
            },
            {
                icon: 'el-icon-data-analysis',
                title: '巡更看板',
                id: 846,
                index: 'PatrolView'
            }
        ]
    }
];

// 护理员 -班组长
export const groupNurse = [
    {
        id: 1,
        icon: 'el-icon-office-building',
        title: '院务管理',
        index: 'SystemMain',
        subs: [
            {
                icon: 'el-icon-lx-service',
                title: '护工班组管理',
                id: 13,
                index: 'NursingManagement'
            }
        ]
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 2,
        index: 'AdmissionOlderList'
    },
    {
        icon: 'el-icon-coordinate',
        title: '护理管理',
        id: 4,
        index: 'careManage',
        subs: [
            {
                icon: 'el-icon-date',
                title: '排班计划',
                id: 41,
                index: 'ThisWeekArrangePlan'
            },
            {
                icon: 'el-icon-notebook-2',
                title: '护理记录',
                id: 42,
                index: 'LifeServiceManagement',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '交班日志',
                        id: 421,
                        index: 'NursingHandoverLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护工护理日志',
                        id: 423,
                        index: 'NursingLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '班长日志',
                        id: 425,
                        index: 'MonitorLog'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '值班日志',
                        id: 427,
                        index: 'DutyLogList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '日常护理记录',
                        id: 428,
                        index: 'TableCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '特殊护理记录',
                        id: 429,
                        index: 'TableSpecialCareList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '长者护理记录',
                        id: 4210,
                        index: 'TableCareProject'
                    },
                ]
            },
            {
                icon: 'el-icon-notebook-2',
                title: '护理计划',
                id: 4211,
                index: 'CarePlanManage',
                subs: [
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理项目管理',
                        id: 42112,
                        index: 'NursingProjectList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理模板管理',
                        id: 42113,
                        index: 'NursingTemplateList'
                    },
                    {
                        icon: 'el-icon-notebook-2',
                        title: '护理计划管理',
                        id: 42111,
                        index: 'CarePlanList'
                    },
                    {
                        icon: 'el-icon-user-solid',
                        title: '护理组管理',
                        id: 4220,
                        index: 'NursingGroupManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组增加',
                                id: 42201,
                                index: 'CareNursingGroupAdd'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组变更',
                                id: 42202,
                                index: 'CareNursingGroupChange'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '护理组查询',
                                id: 42203,
                                index: 'CareNursingGroupQuery'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '班次设置',
                                id: 42204,
                                index: 'RoomShiftSetting'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '排班管理',
                                id: 42205,
                                index: 'RoomScheduleIndex'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-date',
                        title: '护理任务管理',
                        id: 4230,
                        index: 'NursingTaskManage',
                        subs: [
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务自动生成',
                                id: 42301,
                                index: 'CareNursingTaskGenerate'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务监控',
                                id: 42302,
                                index: 'CareNursingTaskMonitor'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '任务执行打卡',
                                id: 42303,
                                index: 'CareNursingTaskPunch'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '超时预警',
                                id: 42304,
                                index: 'CareNursingTaskTimeout'
                            },
                            {
                                icon: 'el-icon-notebook-2',
                                title: '异常上报',
                                id: 42305,
                                index: 'CareNursingTaskException'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-document',
                        title: '护理记录管理',
                        id: 4240,
                        index: 'CareNursingRecordView'
                    },
                    {
                        icon: 'el-icon-connection',
                        title: '整合查看',
                        id: 4250,
                        index: 'NursingIntegrateReport'
                    },
                    {
                        icon: 'el-icon-data-line',
                        title: '数据统计',
                        id: 4260,
                        index: 'NursingStatsDashboard'
                    },
                    {
                        icon: 'el-icon-money',
                        title: '护理计费',
                        id: 4270,
                        index: 'NursingBillList'
                    }
                ]
            },
            {
                icon: 'el-icon-lx-crown',
                title: '老人生日',
                id: 43,
                index: 'OldmanBirthday'
            },
            {
                icon: 'el-icon-lx-forward',
                title: '老人请假',
                id: 44,
                index: 'OldmanLeave'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '体检记录',
                id: 48,
                index: 'MedicalCare'
            },
            {
                icon: 'el-icon-guide',
                title: '调房调级申请',
                id: 452,
                index: 'changeFeeList'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '出院办理',
                id: 4051,
                index: 'LeaveHistoryList'
            },
            {
                icon: 'el-icon-takeaway-box',
                title: '用药管理',
                id: 46,
                index: 'MedicalManage',
                subs: [
                    {
                        icon: 'el-icon-takeaway-box',
                        title: '用药记录',
                        id: 461,
                        index: 'PharmacyRecord'
                    },
                    {
                        icon: 'el-icon-document',
                        title: '历史用药记录',
                        id: 462,
                        index: 'PharmacyHistoryRecord'
                    },
                    {
                        icon: 'el-icon-attract',
                        title: '用药计划',
                        id: 463,
                        index: 'MedicalPlanList'
                    }
                ]
            }
        ]
    },
    {
        icon: 'el-icon-phone-outline',
        title: '应急呼叫管理',
        id: 7,
        index: 'Alarmlog'
    }
];

//养老机构的接待
export const groupReception = [
    {
        id: 1,
        icon: 'el-icon-office-building',
        title: '工作台',
        index: 'SystemMain'
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 2,
        index: 'AdmissionOlderList'
    },
    {
        icon: 'el-icon-lx-profile',
        title: '前台管理',
        id: 21,
        index: 'AdmissionManager',
        subs: [
            {
                icon: 'el-icon-refrigerator',
                title: '预约咨询',
                id: 211,
                index: 'AdmissionConsult'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '取消预约',
                id: 212,
                index: 'AdmissionCancel'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '入院评估',
                id: 213,
                index: 'AdmissionPg'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '入院办理',
                id: 214,
                index: 'AdmissionOlderList'
            },
            {
                icon: 'el-icon-date',
                title: '入院参观信息',
                id: 406,
                index: 'OldVisitTable'
            },
            {
                icon: 'el-icon-date',
                title: '预约登记表',
                id: 4061,
                index: 'OldReservationTable'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '院民出入登记表',
                id: 407,
                index: 'EldOutTable'
            },
            {
                icon: 'el-icon-lx-crown',
                title: '老人生日',
                id: 43,
                index: 'OldmanBirthday'
            },
            {
                icon: 'el-icon-guide',
                title: '调房调级',
                id: 45,
                index: 'ReviseRecordList'
            }
        ]
    },
    {
        icon: 'el-icon-document',
        title: '合同管理',
        id: 24,
        index: 'ContractManage'
    },
    {
        icon: 'el-icon-refrigerator',
        title: '出院办理',
        id: 4051,
        index: 'LeaveHistoryList'
    },
    {
        icon: 'el-icon-school',
        title: '楼栋房间管理',
        id: 14,
        index: 'RoomBedManager',
        subs: [
            {
                icon: 'el-icon-office-building',
                title: '楼栋管理',
                id: 141,
                index: 'BuildView'
            },
            {
                icon: 'el-icon-house',
                title: '房间管理',
                id: 142,
                index: 'RoomSetting'
            },
            {
                icon: 'el-icon-folder',
                title: '床位管理',
                id: 143,
                index: 'BedSetting'
            },
            {
                id: 144,
                index: 'RoomView',
                title: '床位视图',
                icon: 'el-icon-view'
            },
            {
                icon: 'el-icon-link',
                title: '床位重排',
                id: 145,
                index: 'BedRearrangement'
            }
        ]
    },
    {
        icon: 'el-icon-lx-home',
        title: '部门员工管理',
        id: 11,
        index: 'Department'
    },
    {
        icon: 'el-icon-setting',
        title: '系统设置',
        id: 9,
        index: 'SetManagement',
        subs: [
            {
                icon: 'el-icon-office-building',
                title: '机构介绍',
                id: 91,
                index: 'GroupInfo'
            },
            {
                icon: 'el-icon-postcard',
                title: '信息发布',
                id: 92,
                index: 'InformationMassagePush'
            },
            {
                icon: 'el-icon-medal-1',
                title: '活动发布',
                id: 93,
                index: 'ActiveList'
            }
        ]
    }
];

export const groupCharge = [
    {
        id: 1,
        icon: 'el-icon-office-building',
        title: '院务管理',
        index: 'SystemMain',
        subs: [
            {
                icon: 'el-icon-lx-punch',
                title: '员工考勤管理',
                id: 12,
                index: 'KaoqinView'
            }
        ]
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 2,
        index: 'AdmissionOlderList',
        subs: [
            {
                icon: 'el-icon-document',
                title: '合同管理',
                id: 24,
                index: 'ContractManage'
            }
        ]
    },
    {
        icon: 'el-icon-lx-redpacket',
        title: '财务管理',
        id: 3,
        index: 'ChargeManagement',
        subs: [
            {
                icon: 'el-icon-data-analysis',
                title: '月度费用绘总',
                id: 31,
                index: 'MonthFinanceView'
            },
            {
                icon: 'el-icon-money',
                title: '月度应收账款',
                id: 312,
                index: 'MonthReceivableList'
            },
            {
                icon: 'el-icon-tickets',
                title: '费用记录单',
                id: 32,
                index: 'PaymentRecord'
            },
            {
                icon: 'el-icon-wallet',
                title: '消费记录',
                id: 323,
                index: 'ConsumptionRecord'
            },
            {
                icon: 'el-icon-money',
                title: '缴费审核记录',
                id: 324,
                index: 'RechargeRecord'
            },
            {
                icon: 'el-icon-lx-recharge',
                title: '余额管理',
                id: 34,
                index: 'ArrearageList'
            },
            {
                // FeeBindList
                icon: 'el-icon-money',
                title: '月度费用绑定清单',
                id: 342,
                index: 'FeeBindList'
            },
            {
                icon: 'el-icon-suitcase-1',
                title: '收费项目管理',
                id: 33,
                index: 'ChargeCategoryManagement'
            },
            {
                icon: 'el-icon-coordinate',
                title: '老人类别管理',
                id: 36,
                index: 'PersonCategoryManagement'
            },
            {
                icon: 'el-icon-money',
                title: '老人类别减免',
                id: 37,
                index: 'personCategoryReduction'
            }
        ]
    },
    {
        icon: 'el-icon-truck',
        title: '物资管理',
        id: 5,
        index: 'WuziManage',
        subs: [
            {
                icon: 'el-icon-box',
                title: '物资项目管理',
                id: 51,
                index: 'StorageCatalogManage'
            },
            {
                icon: 'el-icon-shopping-cart-full',
                title: '物资库存表',
                id: 52,
                index: 'StorageStockManage'
            },
            {
                icon: 'el-icon-sell',
                title: '物资入库表',
                id: 53,
                index: 'StorageInTable'
            },
            {
                icon: 'el-icon-sold-out',
                title: '物资出库表',
                id: 54,
                index: 'StorageOutTable'
            },
            {
                icon: 'el-icon-document-checked',
                title: '物资消杀登记',
                id: 55,
                index: 'WuZiResign'
            }
        ]
    }
];

//s市场主体
export const merchanalList = [
    {
        id: 1,
        icon: 'el-icon-data-line',
        title: '系统首页',
        index: 'SiteChart'
    },
    {
        id: 2,
        icon: 'el-icon-office-building',
        title: '站点管理',
        index: 'SiteManagement',
        subs: [
            {
                icon: 'el-icon-document',
                title: '基础信息',
                id: 21,
                index: 'BaseInfo'
            },
            {
                icon: 'el-icon-lx-home',
                title: '员工账号管理',
                id: 11,
                index: 'Department'
            },
            {
                icon: 'el-icon-office-building',
                title: '站点介绍',
                id: 24,
                index: 'SiteInfo'
            },
            {
                icon: 'el-icon-postcard',
                title: '信息发布',
                id: 25,
                index: 'InformationMassagePush'
            },
            {
                icon: 'el-icon-medal-1',
                title: '活动发布',
                id: 26,
                index: 'ActiveList'
            }
        ]
    },
    {
        icon: 'el-icon-lx-group',
        title: '长者管理',
        id: 3,
        index: 'ResidentManager',
        subs: [
            {
                icon: 'el-icon-lx-addressbook',
                title: '长者信息',
                id: 31,
                index: 'ResidentManager'
            },
            {
                icon: 'el-icon-refrigerator',
                title: '长者迁出',
                id: 34,
                index: 'ResidentLeave'
            },
            {
                icon: 'el-icon-lx-global',
                title: '长者地图',
                id: 36,
                index: 'Oldmanmap'
            },
            {
                icon: 'el-icon-lx-crown',
                title: '老人生日',
                id: 37,
                index: 'OldmanBirthday'
            },
            {
                icon: 'el-icon-coordinate',
                title: '老人类别管理',
                id: 38,
                index: 'PersonCategoryManagement'
            }
        ]
    },
    {
        id: 4,
        icon: 'el-icon-coordinate',
        title: '居家服务',
        index: 'ServiceManage',
        subs: [
            {
                id: 44,
                title: '服务工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceWorkOrder'
            },
            {
                id: 441,
                title: '异常工单管理',
                icon: 'el-icon-tickets',
                index: 'ServiceErrorWorkOrder'
            },
            {
                id: 45,
                title: '统计报表',
                icon: 'el-icon-pie-chart',
                index: 'ServiceReport'
            },
            {
                id: 46,
                title: '评论管理',
                icon: 'el-icon-collection-tag',
                index: 'serviceComment'
            },
            {
                id: 40,
                icon: 'el-icon-wallet',
                title: '服务类别管理',
                index: 'ServiceCategoryNew'
            },
            {
                id: 43,
                title: '服务人员管理',
                icon: 'el-icon-coordinate',
                index: 'ServicePersonnel'
            }
        ]
    }
];


